var _g, _g2, _g3, _g4, _path, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaintenanceImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 315.001,
    height: 403.746,
    viewBox: "0 0 315.001 403.746",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_2376",
    "data-name": "Group 2376",
    transform: "translate(-725.999 -132.127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2375",
    "data-name": "Group 2375",
    transform: "translate(114.783 66.042)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2235",
    "data-name": "Group 2235",
    transform: "translate(630.84 69.033)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2159",
    "data-name": "Group 2159",
    transform: "translate(38.501 284.234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3405",
    "data-name": "Path 3405",
    d: "M378.739,264.305v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-364.325 -254.585)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3406",
    "data-name": "Path 3406",
    d: "M383.559,266.623v2.761l-14.421-8.334V258.3Z",
    transform: "translate(-369.138 -256.903)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3407",
    "data-name": "Path 3407",
    d: "M369.138,258.762l14.421,8.327,2.4-1.386-14.434-8.334Z",
    transform: "translate(-369.138 -257.368)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2160",
    "data-name": "Group 2160",
    transform: "translate(21.758 284.234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3408",
    "data-name": "Path 3408",
    d: "M360.394,264.305v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-357.986 -254.585)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3409",
    "data-name": "Path 3409",
    d: "M359.586,266.623v2.761l14.421-8.334V258.3Z",
    transform: "translate(-357.185 -256.903)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3410",
    "data-name": "Path 3410",
    d: "M374.808,258.762l-14.421,8.327-2.4-1.386,14.433-8.334Z",
    transform: "translate(-357.986 -257.368)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2161",
    "data-name": "Group 2161",
    transform: "translate(38.501 306.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3411",
    "data-name": "Path 3411",
    d: "M378.739,279.07v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-364.325 -269.349)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3412",
    "data-name": "Path 3412",
    d: "M383.559,281.387v2.761l-14.421-8.334V273.06Z",
    transform: "translate(-369.138 -271.667)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3413",
    "data-name": "Path 3413",
    d: "M369.138,273.526l14.421,8.327,2.4-1.387-14.434-8.334Z",
    transform: "translate(-369.138 -272.132)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2162",
    "data-name": "Group 2162",
    transform: "translate(21.758 306.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3414",
    "data-name": "Path 3414",
    d: "M360.394,279.07v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-357.986 -269.349)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3415",
    "data-name": "Path 3415",
    d: "M359.586,281.387v2.761l14.421-8.334V273.06Z",
    transform: "translate(-357.185 -271.667)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3416",
    "data-name": "Path 3416",
    d: "M374.808,273.526l-14.421,8.327-2.4-1.387,14.433-8.334Z",
    transform: "translate(-357.986 -272.132)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2163",
    "data-name": "Group 2163",
    transform: "translate(38.501 239.957)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3417",
    "data-name": "Path 3417",
    d: "M378.739,234.814v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-364.325 -225.093)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3418",
    "data-name": "Path 3418",
    d: "M383.559,237.131v2.761l-14.421-8.334V228.8Z",
    transform: "translate(-369.138 -227.411)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3419",
    "data-name": "Path 3419",
    d: "M369.138,229.27l14.421,8.327,2.4-1.387-14.434-8.334Z",
    transform: "translate(-369.138 -227.876)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2164",
    "data-name": "Group 2164",
    transform: "translate(21.758 239.957)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3420",
    "data-name": "Path 3420",
    d: "M360.394,234.814v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-357.986 -225.093)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3421",
    "data-name": "Path 3421",
    d: "M359.586,237.131v2.761l14.421-8.334V228.8Z",
    transform: "translate(-357.185 -227.411)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3422",
    "data-name": "Path 3422",
    d: "M374.808,229.27,360.388,237.6l-2.4-1.387,14.433-8.334Z",
    transform: "translate(-357.986 -227.876)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2165",
    "data-name": "Group 2165",
    transform: "translate(38.501 262.123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3423",
    "data-name": "Path 3423",
    d: "M378.739,249.578v2.761l2.408-1.387v-2.761Z",
    transform: "translate(-364.325 -239.857)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3424",
    "data-name": "Path 3424",
    d: "M383.559,251.9v2.761l-14.421-8.334v-2.753Z",
    transform: "translate(-369.138 -242.175)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3425",
    "data-name": "Path 3425",
    d: "M369.138,244.034l14.421,8.327,2.4-1.386-14.434-8.334Z",
    transform: "translate(-369.138 -242.64)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2166",
    "data-name": "Group 2166",
    transform: "translate(21.758 262.123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3426",
    "data-name": "Path 3426",
    d: "M360.394,249.578v2.761l-2.408-1.387v-2.761Z",
    transform: "translate(-357.986 -239.857)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3427",
    "data-name": "Path 3427",
    d: "M359.586,251.9v2.761l14.421-8.334v-2.753Z",
    transform: "translate(-357.185 -242.175)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3428",
    "data-name": "Path 3428",
    d: "M374.808,244.034l-14.421,8.327-2.4-1.386,14.433-8.334Z",
    transform: "translate(-357.986 -242.64)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2167",
    "data-name": "Group 2167",
    transform: "translate(38.501 195.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3429",
    "data-name": "Path 3429",
    d: "M378.739,205.337V208.1l2.408-1.386V203.95Z",
    transform: "translate(-364.325 -195.616)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3430",
    "data-name": "Path 3430",
    d: "M383.559,207.654v2.761l-14.421-8.334v-2.753Z",
    transform: "translate(-369.138 -197.934)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3431",
    "data-name": "Path 3431",
    d: "M369.138,199.793l14.421,8.327,2.4-1.386L371.527,198.4Z",
    transform: "translate(-369.138 -198.399)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2168",
    "data-name": "Group 2168",
    transform: "translate(21.758 195.702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3432",
    "data-name": "Path 3432",
    d: "M360.394,205.337V208.1l-2.408-1.386V203.95Z",
    transform: "translate(-357.986 -195.616)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3433",
    "data-name": "Path 3433",
    d: "M359.586,207.654v2.761l14.421-8.334v-2.753Z",
    transform: "translate(-357.185 -197.934)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3434",
    "data-name": "Path 3434",
    d: "M374.808,199.793l-14.421,8.327-2.4-1.386L372.42,198.4Z",
    transform: "translate(-357.986 -198.399)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2169",
    "data-name": "Group 2169",
    transform: "translate(38.501 217.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3435",
    "data-name": "Path 3435",
    d: "M378.739,220.1v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-364.325 -210.38)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3436",
    "data-name": "Path 3436",
    d: "M383.559,222.418v2.761l-14.421-8.334v-2.753Z",
    transform: "translate(-369.138 -212.698)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3437",
    "data-name": "Path 3437",
    d: "M369.138,214.557l14.421,8.327,2.4-1.386-14.434-8.334Z",
    transform: "translate(-369.138 -213.163)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2170",
    "data-name": "Group 2170",
    transform: "translate(21.758 217.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3438",
    "data-name": "Path 3438",
    d: "M360.394,220.1v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-357.986 -210.38)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3439",
    "data-name": "Path 3439",
    d: "M359.586,222.418v2.761l14.421-8.334v-2.753Z",
    transform: "translate(-357.185 -212.698)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3440",
    "data-name": "Path 3440",
    d: "M374.808,214.557l-14.421,8.327-2.4-1.386,14.433-8.334Z",
    transform: "translate(-357.986 -213.163)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2171",
    "data-name": "Group 2171",
    transform: "translate(0 312.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3442",
    "data-name": "Path 3442",
    d: "M369.1,316.953l39.012-22.429v-3.585L369.1,313.37Z",
    transform: "translate(-330.656 -268.514)",
    fill: "#5066e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3443",
    "data-name": "Path 3443",
    d: "M343.494,294.515l38.468,22.429V313.36l-38.468-22.4Z",
    transform: "translate(-343.494 -268.504)",
    fill: "#5066e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3444",
    "data-name": "Path 3444",
    d: "M343.494,298.458l38.468,22.4,38.99-22.431L382.443,276Z",
    transform: "translate(-343.494 -276.003)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3445",
    "data-name": "Path 3445",
    d: "M343.494,290.969l38.468,22.4,38.99-22.431-38.862,21.667Z",
    transform: "translate(-343.494 -268.514)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3446",
    "data-name": "Path 3446",
    d: "M369.176,306.605l23.613-13.576v-4.578l-23.613,13.577Z",
    transform: "translate(-330.618 -269.761)",
    fill: "#5066e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3447",
    "data-name": "Path 3447",
    d: "M353.676,293.024,376.96,306.6v-4.577l-23.284-13.559Z",
    transform: "translate(-338.389 -269.755)",
    fill: "#5066e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3448",
    "data-name": "Path 3448",
    d: "M353.676,293l23.284,13.559,23.6-13.577L377.251,279.41Z",
    transform: "translate(-338.389 -274.294)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3449",
    "data-name": "Path 3449",
    d: "M353.676,288.47l23.284,13.559,23.6-13.577-23.523,12.679Z",
    transform: "translate(-338.389 -269.761)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2172",
    "data-name": "Group 2172",
    transform: "translate(38.501 62.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3450",
    "data-name": "Path 3450",
    d: "M378.739,116.795v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-364.325 -107.074)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3451",
    "data-name": "Path 3451",
    d: "M383.559,119.112v2.761l-14.421-8.334v-2.753Z",
    transform: "translate(-369.138 -109.392)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3452",
    "data-name": "Path 3452",
    d: "M369.138,111.251l14.421,8.327,2.4-1.386-14.434-8.334Z",
    transform: "translate(-369.138 -109.857)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2173",
    "data-name": "Group 2173",
    transform: "translate(38.501 85.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3453",
    "data-name": "Path 3453",
    d: "M378.739,131.606v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-364.325 -121.885)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3454",
    "data-name": "Path 3454",
    d: "M383.559,133.923v2.761l-14.421-8.334V125.6Z",
    transform: "translate(-369.138 -124.203)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3455",
    "data-name": "Path 3455",
    d: "M369.138,126.062l14.421,8.327,2.4-1.387-14.434-8.334Z",
    transform: "translate(-369.138 -124.668)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2174",
    "data-name": "Group 2174",
    transform: "translate(38.501 107.156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3456",
    "data-name": "Path 3456",
    d: "M378.739,146.359v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-364.325 -136.639)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3457",
    "data-name": "Path 3457",
    d: "M383.559,148.677v2.761L369.138,143.1V140.35Z",
    transform: "translate(-369.138 -138.956)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3458",
    "data-name": "Path 3458",
    d: "M369.138,140.816l14.421,8.327,2.4-1.386-14.434-8.334Z",
    transform: "translate(-369.138 -139.422)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2175",
    "data-name": "Group 2175",
    transform: "translate(38.501 129.231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3459",
    "data-name": "Path 3459",
    d: "M378.739,161.062v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-364.325 -151.342)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3460",
    "data-name": "Path 3460",
    d: "M383.559,163.38v2.761l-14.421-8.334v-2.753Z",
    transform: "translate(-369.138 -153.659)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3461",
    "data-name": "Path 3461",
    d: "M369.138,155.518l14.421,8.327,2.4-1.387-14.434-8.334Z",
    transform: "translate(-369.138 -154.125)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2176",
    "data-name": "Group 2176",
    transform: "translate(38.501 151.467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3462",
    "data-name": "Path 3462",
    d: "M378.739,175.873v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-364.325 -166.153)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3463",
    "data-name": "Path 3463",
    d: "M383.559,178.191v2.761l-14.421-8.334v-2.753Z",
    transform: "translate(-369.138 -168.47)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3464",
    "data-name": "Path 3464",
    d: "M369.138,170.33l14.421,8.327,2.4-1.387-14.434-8.334Z",
    transform: "translate(-369.138 -168.936)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2177",
    "data-name": "Group 2177",
    transform: "translate(38.501 173.617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3465",
    "data-name": "Path 3465",
    d: "M378.739,190.627v2.761L381.147,192V189.24Z",
    transform: "translate(-364.325 -180.906)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3466",
    "data-name": "Path 3466",
    d: "M383.559,192.944v2.761l-14.421-8.334v-2.753Z",
    transform: "translate(-369.138 -183.224)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3467",
    "data-name": "Path 3467",
    d: "M369.138,185.083l14.421,8.327,2.4-1.386-14.434-8.334Z",
    transform: "translate(-369.138 -183.689)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2178",
    "data-name": "Group 2178",
    transform: "translate(52.945 18.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3468",
    "data-name": "Path 3468",
    d: "M380.346,82.946V393.8l2.408-1.386V81.56Z",
    transform: "translate(-377.964 -80.174)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3469",
    "data-name": "Path 3469",
    d: "M381.148,82.944V393.8l-2.389-1.387V81.565Z",
    transform: "translate(-378.759 -80.171)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3470",
    "data-name": "Path 3470",
    d: "M378.759,82.03l2.389,1.379,2.4-1.386-2.4-1.386Z",
    transform: "translate(-378.759 -80.637)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2179",
    "data-name": "Group 2179",
    transform: "translate(36.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3471",
    "data-name": "Path 3471",
    d: "M369.194,70.358V259.539l2.408-1.386V68.972Z",
    transform: "translate(-366.812 -67.585)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3472",
    "data-name": "Path 3472",
    d: "M370,70.356V259.537l-2.388-1.386V68.977Z",
    transform: "translate(-367.607 -67.583)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3473",
    "data-name": "Path 3473",
    d: "M367.607,69.442,370,70.821l2.4-1.386L370,68.048Z",
    transform: "translate(-367.607 -68.048)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2180",
    "data-name": "Group 2180",
    transform: "translate(21.758 62.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3474",
    "data-name": "Path 3474",
    d: "M360.394,116.795v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-357.986 -107.074)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3475",
    "data-name": "Path 3475",
    d: "M359.586,119.112v2.761l14.421-8.334v-2.753Z",
    transform: "translate(-357.185 -109.392)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3476",
    "data-name": "Path 3476",
    d: "M374.808,111.251l-14.421,8.327-2.4-1.386,14.433-8.334Z",
    transform: "translate(-357.986 -109.857)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2181",
    "data-name": "Group 2181",
    transform: "translate(21.758 85.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3477",
    "data-name": "Path 3477",
    d: "M360.394,131.606v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-357.986 -121.885)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3478",
    "data-name": "Path 3478",
    d: "M359.586,133.923v2.761l14.421-8.334V125.6Z",
    transform: "translate(-357.185 -124.203)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3479",
    "data-name": "Path 3479",
    d: "M374.808,126.062l-14.421,8.327-2.4-1.387,14.433-8.334Z",
    transform: "translate(-357.986 -124.668)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2182",
    "data-name": "Group 2182",
    transform: "translate(21.758 107.156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3480",
    "data-name": "Path 3480",
    d: "M360.394,146.359v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-357.986 -136.639)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3481",
    "data-name": "Path 3481",
    d: "M359.586,148.677v2.761l14.421-8.334V140.35Z",
    transform: "translate(-357.185 -138.956)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3482",
    "data-name": "Path 3482",
    d: "M374.808,140.816l-14.421,8.327-2.4-1.386,14.433-8.334Z",
    transform: "translate(-357.986 -139.422)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2183",
    "data-name": "Group 2183",
    transform: "translate(21.758 129.231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3483",
    "data-name": "Path 3483",
    d: "M360.394,161.062v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-357.986 -151.342)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3484",
    "data-name": "Path 3484",
    d: "M359.586,163.38v2.761l14.421-8.334v-2.753Z",
    transform: "translate(-357.185 -153.659)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3485",
    "data-name": "Path 3485",
    d: "M374.808,155.518l-14.421,8.327-2.4-1.387,14.433-8.334Z",
    transform: "translate(-357.986 -154.125)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2184",
    "data-name": "Group 2184",
    transform: "translate(21.758 151.467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3486",
    "data-name": "Path 3486",
    d: "M360.394,175.873v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-357.986 -166.153)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3487",
    "data-name": "Path 3487",
    d: "M359.586,178.191v2.761l14.421-8.334v-2.753Z",
    transform: "translate(-357.185 -168.47)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3488",
    "data-name": "Path 3488",
    d: "M374.808,170.33l-14.421,8.327-2.4-1.387,14.433-8.334Z",
    transform: "translate(-357.986 -168.936)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2185",
    "data-name": "Group 2185",
    transform: "translate(21.758 173.617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3489",
    "data-name": "Path 3489",
    d: "M360.394,190.627v2.761L357.986,192V189.24Z",
    transform: "translate(-357.986 -180.906)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3490",
    "data-name": "Path 3490",
    d: "M359.586,192.944v2.761l14.421-8.334v-2.753Z",
    transform: "translate(-357.185 -183.224)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3491",
    "data-name": "Path 3491",
    d: "M374.808,185.083l-14.421,8.327-2.4-1.386,14.433-8.334Z",
    transform: "translate(-357.986 -183.689)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2186",
    "data-name": "Group 2186",
    transform: "translate(19.382 9.484)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3492",
    "data-name": "Path 3492",
    d: "M357.991,76.675v320.3l2.408-1.386V75.289Z",
    transform: "translate(-355.609 -73.902)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3493",
    "data-name": "Path 3493",
    d: "M358.792,76.673v320.3l-2.389-1.386V75.294Z",
    transform: "translate(-356.404 -73.9)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3494",
    "data-name": "Path 3494",
    d: "M356.4,75.759l2.389,1.379,2.4-1.386-2.4-1.386Z",
    transform: "translate(-356.404 -74.365)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2187",
    "data-name": "Group 2187",
    transform: "translate(21.758 316.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3495",
    "data-name": "Path 3495",
    d: "M367.587,285.624v2.761L369.995,287v-2.761Z",
    transform: "translate(-353.173 -275.904)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3496",
    "data-name": "Path 3496",
    d: "M372.407,287.942V290.7l-14.421-8.334v-2.753Z",
    transform: "translate(-357.986 -278.222)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3497",
    "data-name": "Path 3497",
    d: "M357.986,280.081l14.421,8.327,2.4-1.386-14.433-8.334Z",
    transform: "translate(-357.986 -278.687)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2188",
    "data-name": "Group 2188",
    transform: "translate(21.758 297.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3498",
    "data-name": "Path 3498",
    d: "M367.587,283.757v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-353.173 -257.628)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3499",
    "data-name": "Path 3499",
    d: "M372.407,291.554v2.761l-14.421-24.743v-2.753Z",
    transform: "translate(-357.986 -265.425)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3500",
    "data-name": "Path 3500",
    d: "M357.986,267.284l14.421,24.736,2.4-1.386L360.375,265.89Z",
    transform: "translate(-357.986 -265.89)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2189",
    "data-name": "Group 2189",
    transform: "translate(21.758 294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3501",
    "data-name": "Path 3501",
    d: "M367.587,270.86v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-353.173 -261.14)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3502",
    "data-name": "Path 3502",
    d: "M372.407,273.178v2.761L357.986,267.6v-2.753Z",
    transform: "translate(-357.986 -263.457)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3503",
    "data-name": "Path 3503",
    d: "M357.986,265.317l14.421,8.327,2.4-1.386-14.433-8.334Z",
    transform: "translate(-357.986 -263.923)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2190",
    "data-name": "Group 2190",
    transform: "translate(21.758 274.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3504",
    "data-name": "Path 3504",
    d: "M367.587,268.993v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-353.173 -242.864)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3505",
    "data-name": "Path 3505",
    d: "M372.407,276.79v2.761l-14.421-24.743v-2.753Z",
    transform: "translate(-357.986 -250.661)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3506",
    "data-name": "Path 3506",
    d: "M357.986,252.52l14.421,24.736,2.4-1.386-14.433-24.743Z",
    transform: "translate(-357.986 -251.126)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2191",
    "data-name": "Group 2191",
    transform: "translate(21.758 271.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3507",
    "data-name": "Path 3507",
    d: "M367.587,256.133v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-353.173 -246.412)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3508",
    "data-name": "Path 3508",
    d: "M372.407,258.45v2.761l-14.421-8.334v-2.753Z",
    transform: "translate(-357.986 -248.73)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3509",
    "data-name": "Path 3509",
    d: "M357.986,250.589l14.421,8.327,2.4-1.387L360.375,249.2Z",
    transform: "translate(-357.986 -249.195)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2192",
    "data-name": "Group 2192",
    transform: "translate(21.758 252.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3510",
    "data-name": "Path 3510",
    d: "M367.587,254.266v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-353.173 -228.136)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3511",
    "data-name": "Path 3511",
    d: "M372.407,262.063v2.761L357.986,240.08v-2.753Z",
    transform: "translate(-357.986 -235.933)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3512",
    "data-name": "Path 3512",
    d: "M357.986,237.792l14.421,24.736,2.4-1.387L360.375,236.4Z",
    transform: "translate(-357.986 -236.398)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2193",
    "data-name": "Group 2193",
    transform: "translate(21.758 249.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3513",
    "data-name": "Path 3513",
    d: "M367.587,241.368v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-353.173 -231.648)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3514",
    "data-name": "Path 3514",
    d: "M372.407,243.686v2.761l-14.421-8.334v-2.753Z",
    transform: "translate(-357.986 -233.966)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3515",
    "data-name": "Path 3515",
    d: "M357.986,235.825l14.421,8.327,2.4-1.386-14.433-8.334Z",
    transform: "translate(-357.986 -234.431)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2194",
    "data-name": "Group 2194",
    transform: "translate(21.758 230.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3516",
    "data-name": "Path 3516",
    d: "M367.587,239.5v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-353.173 -213.372)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3517",
    "data-name": "Path 3517",
    d: "M372.407,247.3v2.761l-14.421-24.743v-2.753Z",
    transform: "translate(-357.986 -221.169)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3518",
    "data-name": "Path 3518",
    d: "M357.986,223.028l14.421,24.736,2.4-1.386-14.433-24.743Z",
    transform: "translate(-357.986 -221.634)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2195",
    "data-name": "Group 2195",
    transform: "translate(21.758 227.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3519",
    "data-name": "Path 3519",
    d: "M367.587,226.656v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-353.173 -216.935)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3520",
    "data-name": "Path 3520",
    d: "M372.407,228.973v2.761L357.986,223.4v-2.753Z",
    transform: "translate(-357.986 -219.253)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3521",
    "data-name": "Path 3521",
    d: "M357.986,221.112l14.421,8.327,2.4-1.386-14.433-8.334Z",
    transform: "translate(-357.986 -219.718)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2196",
    "data-name": "Group 2196",
    transform: "translate(38.501 316.242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3522",
    "data-name": "Path 3522",
    d: "M371.546,285.624v2.761L369.138,287v-2.761Z",
    transform: "translate(-369.138 -275.904)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3523",
    "data-name": "Path 3523",
    d: "M370.738,287.942V290.7l14.421-8.334v-2.753Z",
    transform: "translate(-368.337 -278.222)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3524",
    "data-name": "Path 3524",
    d: "M385.96,280.081l-14.421,8.327-2.4-1.386,14.433-8.334Z",
    transform: "translate(-369.138 -278.687)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2197",
    "data-name": "Group 2197",
    transform: "translate(38.501 296.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3525",
    "data-name": "Path 3525",
    d: "M371.546,285.624v2.761L369.138,287v-2.761Z",
    transform: "translate(-369.138 -256.598)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3526",
    "data-name": "Path 3526",
    d: "M370.738,294.389v2.761l14.421-27.64v-2.753Z",
    transform: "translate(-368.337 -265.363)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3527",
    "data-name": "Path 3527",
    d: "M385.96,267.222,371.54,294.854l-2.4-1.386,14.433-27.64Z",
    transform: "translate(-369.138 -265.828)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2198",
    "data-name": "Group 2198",
    transform: "translate(38.501 294.076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3528",
    "data-name": "Path 3528",
    d: "M371.546,270.86v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-369.138 -261.14)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3529",
    "data-name": "Path 3529",
    d: "M370.738,273.178v2.761l14.421-8.334v-2.753Z",
    transform: "translate(-368.337 -263.457)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3530",
    "data-name": "Path 3530",
    d: "M385.96,265.317l-14.421,8.327-2.4-1.386,14.433-8.334Z",
    transform: "translate(-369.138 -263.923)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2199",
    "data-name": "Group 2199",
    transform: "translate(38.501 274.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3531",
    "data-name": "Path 3531",
    d: "M371.546,270.86v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-369.138 -241.834)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3532",
    "data-name": "Path 3532",
    d: "M370.738,279.625v2.761l14.421-27.64v-2.753Z",
    transform: "translate(-368.337 -250.599)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3533",
    "data-name": "Path 3533",
    d: "M385.96,252.458,371.54,280.09l-2.4-1.386,14.433-27.64Z",
    transform: "translate(-369.138 -251.064)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2200",
    "data-name": "Group 2200",
    transform: "translate(21.758 208.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3534",
    "data-name": "Path 3534",
    d: "M367.587,224.789v2.761l2.408-1.386V223.4Z",
    transform: "translate(-353.173 -198.659)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3535",
    "data-name": "Path 3535",
    d: "M372.407,232.586v2.761L357.986,210.6V207.85Z",
    transform: "translate(-357.986 -206.456)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3536",
    "data-name": "Path 3536",
    d: "M357.986,208.315l14.421,24.736,2.4-1.386-14.433-24.743Z",
    transform: "translate(-357.986 -206.922)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2201",
    "data-name": "Group 2201",
    transform: "translate(38.501 271.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3537",
    "data-name": "Path 3537",
    d: "M371.546,256.133v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-369.138 -246.412)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3538",
    "data-name": "Path 3538",
    d: "M370.738,258.45v2.761l14.421-8.334v-2.753Z",
    transform: "translate(-368.337 -248.73)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3539",
    "data-name": "Path 3539",
    d: "M385.96,250.589l-14.421,8.327-2.4-1.387,14.433-8.334Z",
    transform: "translate(-369.138 -249.195)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2202",
    "data-name": "Group 2202",
    transform: "translate(38.501 252.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3540",
    "data-name": "Path 3540",
    d: "M371.546,256.133v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-369.138 -227.106)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3541",
    "data-name": "Path 3541",
    d: "M370.738,264.9v2.761l14.421-27.64v-2.753Z",
    transform: "translate(-368.337 -235.871)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3542",
    "data-name": "Path 3542",
    d: "M385.96,237.73,371.54,265.362l-2.4-1.387,14.433-27.64Z",
    transform: "translate(-369.138 -236.336)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2203",
    "data-name": "Group 2203",
    transform: "translate(38.501 249.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3543",
    "data-name": "Path 3543",
    d: "M371.546,241.368v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-369.138 -231.648)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3544",
    "data-name": "Path 3544",
    d: "M370.738,243.686v2.761l14.421-8.334v-2.753Z",
    transform: "translate(-368.337 -233.966)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3545",
    "data-name": "Path 3545",
    d: "M385.96,235.825l-14.421,8.327-2.4-1.386,14.433-8.334Z",
    transform: "translate(-369.138 -234.431)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2204",
    "data-name": "Group 2204",
    transform: "translate(21.758 205.543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3546",
    "data-name": "Path 3546",
    d: "M367.587,211.892v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-353.173 -202.171)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3547",
    "data-name": "Path 3547",
    d: "M372.407,214.209v2.761l-14.421-8.334v-2.753Z",
    transform: "translate(-357.986 -204.489)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3548",
    "data-name": "Path 3548",
    d: "M357.986,206.348l14.421,8.327,2.4-1.386-14.433-8.334Z",
    transform: "translate(-357.986 -204.954)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2205",
    "data-name": "Group 2205",
    transform: "translate(21.758 186.331)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3549",
    "data-name": "Path 3549",
    d: "M367.587,210.025v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-353.173 -183.895)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3550",
    "data-name": "Path 3550",
    d: "M372.407,217.822v2.761l-14.421-24.743v-2.753Z",
    transform: "translate(-357.986 -191.692)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3551",
    "data-name": "Path 3551",
    d: "M357.986,193.551l14.421,24.736,2.4-1.386-14.433-24.743Z",
    transform: "translate(-357.986 -192.158)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2206",
    "data-name": "Group 2206",
    transform: "translate(38.501 230.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3552",
    "data-name": "Path 3552",
    d: "M371.546,241.368v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-369.138 -212.342)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3553",
    "data-name": "Path 3553",
    d: "M370.738,250.133v2.761l14.421-27.64V222.5Z",
    transform: "translate(-368.337 -221.107)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3554",
    "data-name": "Path 3554",
    d: "M385.96,222.966,371.54,250.6l-2.4-1.386,14.433-27.64Z",
    transform: "translate(-369.138 -221.572)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2207",
    "data-name": "Group 2207",
    transform: "translate(21.758 183.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3555",
    "data-name": "Path 3555",
    d: "M367.587,197.182v2.761l2.408-1.386V195.8Z",
    transform: "translate(-353.173 -187.461)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3556",
    "data-name": "Path 3556",
    d: "M372.407,199.5v2.761l-14.421-8.334v-2.753Z",
    transform: "translate(-357.986 -189.779)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3557",
    "data-name": "Path 3557",
    d: "M357.986,191.638l14.421,8.327,2.4-1.386-14.433-8.334Z",
    transform: "translate(-357.986 -190.244)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2208",
    "data-name": "Group 2208",
    transform: "translate(21.758 164.246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3558",
    "data-name": "Path 3558",
    d: "M367.587,195.315v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-353.173 -169.185)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3559",
    "data-name": "Path 3559",
    d: "M372.407,203.112v2.761l-14.421-24.743v-2.753Z",
    transform: "translate(-357.986 -176.982)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3560",
    "data-name": "Path 3560",
    d: "M357.986,178.841l14.421,24.736,2.4-1.386-14.433-24.743Z",
    transform: "translate(-357.986 -177.448)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2209",
    "data-name": "Group 2209",
    transform: "translate(38.501 227.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3561",
    "data-name": "Path 3561",
    d: "M371.546,226.656v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-369.138 -216.935)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3562",
    "data-name": "Path 3562",
    d: "M370.738,228.973v2.761l14.421-8.334v-2.753Z",
    transform: "translate(-368.337 -219.253)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3563",
    "data-name": "Path 3563",
    d: "M385.96,221.112l-14.421,8.327-2.4-1.386,14.433-8.334Z",
    transform: "translate(-369.138 -219.718)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2210",
    "data-name": "Group 2210",
    transform: "translate(38.501 208.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3564",
    "data-name": "Path 3564",
    d: "M371.546,226.656v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-369.138 -197.63)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3565",
    "data-name": "Path 3565",
    d: "M370.738,235.42v2.761l14.421-27.64v-2.753Z",
    transform: "translate(-368.337 -206.394)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3566",
    "data-name": "Path 3566",
    d: "M385.96,208.253,371.54,235.886l-2.4-1.386,14.433-27.64Z",
    transform: "translate(-369.138 -206.859)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2211",
    "data-name": "Group 2211",
    transform: "translate(38.501 205.543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3567",
    "data-name": "Path 3567",
    d: "M371.546,211.892v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-369.138 -202.171)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3568",
    "data-name": "Path 3568",
    d: "M370.738,214.209v2.761l14.421-8.334v-2.753Z",
    transform: "translate(-368.337 -204.489)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3569",
    "data-name": "Path 3569",
    d: "M385.96,206.348l-14.421,8.327-2.4-1.386,14.433-8.334Z",
    transform: "translate(-369.138 -204.954)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2212",
    "data-name": "Group 2212",
    transform: "translate(38.501 186.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3570",
    "data-name": "Path 3570",
    d: "M371.546,211.892v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-369.138 -182.866)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3571",
    "data-name": "Path 3571",
    d: "M370.738,220.656v2.761l14.421-27.64v-2.753Z",
    transform: "translate(-368.337 -191.63)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3572",
    "data-name": "Path 3572",
    d: "M385.96,193.489,371.54,221.121l-2.4-1.386,14.433-27.64Z",
    transform: "translate(-369.138 -192.095)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2213",
    "data-name": "Group 2213",
    transform: "translate(21.758 161.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3573",
    "data-name": "Path 3573",
    d: "M367.587,182.428v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-353.173 -172.708)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3574",
    "data-name": "Path 3574",
    d: "M372.407,184.746v2.761l-14.421-8.334v-2.753Z",
    transform: "translate(-357.986 -175.025)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3575",
    "data-name": "Path 3575",
    d: "M357.986,176.884l14.421,8.327,2.4-1.386-14.433-8.334Z",
    transform: "translate(-357.986 -175.491)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2214",
    "data-name": "Group 2214",
    transform: "translate(38.501 183.458)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3576",
    "data-name": "Path 3576",
    d: "M371.546,197.182v2.761l-2.408-1.386V195.8Z",
    transform: "translate(-369.138 -187.461)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3577",
    "data-name": "Path 3577",
    d: "M370.738,199.5v2.761l14.421-8.334v-2.753Z",
    transform: "translate(-368.337 -189.779)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3578",
    "data-name": "Path 3578",
    d: "M385.96,191.638l-14.421,8.327-2.4-1.386,14.433-8.334Z",
    transform: "translate(-369.138 -190.244)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2215",
    "data-name": "Group 2215",
    transform: "translate(38.501 164.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3579",
    "data-name": "Path 3579",
    d: "M371.546,197.182v2.761l-2.408-1.386V195.8Z",
    transform: "translate(-369.138 -168.156)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3580",
    "data-name": "Path 3580",
    d: "M370.738,205.946v2.761l14.421-27.64v-2.753Z",
    transform: "translate(-368.337 -176.92)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3581",
    "data-name": "Path 3581",
    d: "M385.96,178.779,371.54,206.411l-2.4-1.386,14.433-27.64Z",
    transform: "translate(-369.138 -177.385)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2216",
    "data-name": "Group 2216",
    transform: "translate(38.501 161.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3582",
    "data-name": "Path 3582",
    d: "M371.546,182.428v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-369.138 -172.708)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3583",
    "data-name": "Path 3583",
    d: "M370.738,184.746v2.761l14.421-8.334v-2.753Z",
    transform: "translate(-368.337 -175.025)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3584",
    "data-name": "Path 3584",
    d: "M385.96,176.884l-14.421,8.327-2.4-1.386,14.433-8.334Z",
    transform: "translate(-369.138 -175.491)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2217",
    "data-name": "Group 2217",
    transform: "translate(38.501 139.345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3585",
    "data-name": "Path 3585",
    d: "M371.546,180.658v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-369.138 -151.632)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3586",
    "data-name": "Path 3586",
    d: "M370.738,189.422v2.761l14.421-27.64V161.79Z",
    transform: "translate(-368.337 -160.396)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3587",
    "data-name": "Path 3587",
    d: "M385.96,162.255,371.54,189.888l-2.4-1.386,14.433-27.64Z",
    transform: "translate(-369.138 -160.861)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2218",
    "data-name": "Group 2218",
    transform: "translate(38.501 139.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3588",
    "data-name": "Path 3588",
    d: "M371.546,167.617v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-369.138 -157.897)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3589",
    "data-name": "Path 3589",
    d: "M370.738,169.935V172.7l14.421-8.334v-2.753Z",
    transform: "translate(-368.337 -160.214)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3590",
    "data-name": "Path 3590",
    d: "M385.96,162.073,371.54,170.4l-2.4-1.386,14.433-8.334Z",
    transform: "translate(-369.138 -160.68)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2219",
    "data-name": "Group 2219",
    transform: "translate(21.758 72.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3591",
    "data-name": "Path 3591",
    d: "M367.587,123.35v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-353.173 -113.629)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3592",
    "data-name": "Path 3592",
    d: "M372.407,125.667v2.761l-14.421-8.334V117.34Z",
    transform: "translate(-357.986 -115.947)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3593",
    "data-name": "Path 3593",
    d: "M357.986,117.806l14.421,8.327,2.4-1.386-14.433-8.334Z",
    transform: "translate(-357.986 -116.412)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2220",
    "data-name": "Group 2220",
    transform: "translate(38.501 72.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3594",
    "data-name": "Path 3594",
    d: "M371.546,123.35v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-369.138 -113.629)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3595",
    "data-name": "Path 3595",
    d: "M370.738,125.667v2.761l14.421-8.334V117.34Z",
    transform: "translate(-368.337 -115.947)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3596",
    "data-name": "Path 3596",
    d: "M385.96,117.806l-14.421,8.327-2.4-1.386,14.433-8.334Z",
    transform: "translate(-369.138 -116.412)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2221",
    "data-name": "Group 2221",
    transform: "translate(38.501 117.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3597",
    "data-name": "Path 3597",
    d: "M371.546,165.814v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-369.138 -136.788)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3598",
    "data-name": "Path 3598",
    d: "M370.738,174.579v2.761l14.421-27.64v-2.753Z",
    transform: "translate(-368.337 -145.553)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3599",
    "data-name": "Path 3599",
    d: "M385.96,147.412,371.54,175.044l-2.4-1.386,14.433-27.64Z",
    transform: "translate(-369.138 -146.018)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2222",
    "data-name": "Group 2222",
    transform: "translate(38.501 116.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3600",
    "data-name": "Path 3600",
    d: "M371.546,152.914v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-369.138 -143.194)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3601",
    "data-name": "Path 3601",
    d: "M370.738,155.232v2.761l14.421-8.334v-2.753Z",
    transform: "translate(-368.337 -145.511)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3602",
    "data-name": "Path 3602",
    d: "M385.96,147.371,371.54,155.7l-2.4-1.386,14.433-8.334Z",
    transform: "translate(-369.138 -145.977)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2223",
    "data-name": "Group 2223",
    transform: "translate(38.501 94.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3603",
    "data-name": "Path 3603",
    d: "M371.546,151.1v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-369.138 -122.069)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3604",
    "data-name": "Path 3604",
    d: "M370.738,159.86v2.761l14.421-27.64v-2.753Z",
    transform: "translate(-368.337 -130.834)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3605",
    "data-name": "Path 3605",
    d: "M385.96,132.693,371.54,160.325l-2.4-1.386,14.433-27.64Z",
    transform: "translate(-369.138 -131.299)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2224",
    "data-name": "Group 2224",
    transform: "translate(38.501 94.847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3606",
    "data-name": "Path 3606",
    d: "M371.546,138.161v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-369.138 -128.44)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3607",
    "data-name": "Path 3607",
    d: "M370.738,140.478v2.761l14.421-8.334v-2.753Z",
    transform: "translate(-368.337 -130.758)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3608",
    "data-name": "Path 3608",
    d: "M385.96,132.617l-14.421,8.327-2.4-1.386,14.433-8.334Z",
    transform: "translate(-369.138 -131.223)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2225",
    "data-name": "Group 2225",
    transform: "translate(38.501 73.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3609",
    "data-name": "Path 3609",
    d: "M371.546,136.47v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-369.138 -107.444)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3610",
    "data-name": "Path 3610",
    d: "M370.738,145.234v2.761l14.421-27.64V117.6Z",
    transform: "translate(-368.337 -116.208)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3611",
    "data-name": "Path 3611",
    d: "M385.96,118.067,371.54,145.7l-2.4-1.386,14.433-27.64Z",
    transform: "translate(-369.138 -116.673)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2226",
    "data-name": "Group 2226",
    transform: "translate(21.758 142.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3612",
    "data-name": "Path 3612",
    d: "M367.587,180.564v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-353.173 -154.435)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3613",
    "data-name": "Path 3613",
    d: "M372.407,188.362v2.761l-14.421-24.743v-2.753Z",
    transform: "translate(-357.986 -162.232)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3614",
    "data-name": "Path 3614",
    d: "M357.986,164.091l14.421,24.736,2.4-1.386L360.375,162.7Z",
    transform: "translate(-357.986 -162.698)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2227",
    "data-name": "Group 2227",
    transform: "translate(21.758 139.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3615",
    "data-name": "Path 3615",
    d: "M367.587,167.617v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-353.173 -157.897)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3616",
    "data-name": "Path 3616",
    d: "M372.407,169.935V172.7l-14.421-8.334v-2.753Z",
    transform: "translate(-357.986 -160.214)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3617",
    "data-name": "Path 3617",
    d: "M357.986,162.073l14.421,8.327,2.4-1.386-14.433-8.334Z",
    transform: "translate(-357.986 -160.68)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2228",
    "data-name": "Group 2228",
    transform: "translate(21.758 119.956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3618",
    "data-name": "Path 3618",
    d: "M367.587,165.814v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-353.173 -139.685)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3619",
    "data-name": "Path 3619",
    d: "M372.407,173.611v2.761l-14.421-24.743v-2.753Z",
    transform: "translate(-357.986 -147.482)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3620",
    "data-name": "Path 3620",
    d: "M357.986,149.341l14.421,24.736,2.4-1.386-14.433-24.743Z",
    transform: "translate(-357.986 -147.947)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2229",
    "data-name": "Group 2229",
    transform: "translate(21.758 116.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3621",
    "data-name": "Path 3621",
    d: "M367.587,152.914v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-353.173 -143.194)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3622",
    "data-name": "Path 3622",
    d: "M372.407,155.232v2.761l-14.421-8.334v-2.753Z",
    transform: "translate(-357.986 -145.511)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3623",
    "data-name": "Path 3623",
    d: "M357.986,147.371l14.421,8.327,2.4-1.386-14.433-8.334Z",
    transform: "translate(-357.986 -145.977)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2230",
    "data-name": "Group 2230",
    transform: "translate(21.758 97.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3624",
    "data-name": "Path 3624",
    d: "M367.587,151.064v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-353.173 -124.935)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3625",
    "data-name": "Path 3625",
    d: "M372.407,158.861v2.761l-14.421-24.743v-2.753Z",
    transform: "translate(-357.986 -132.732)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3626",
    "data-name": "Path 3626",
    d: "M357.986,134.591l14.421,24.736,2.4-1.386L360.375,133.2Z",
    transform: "translate(-357.986 -133.197)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2231",
    "data-name": "Group 2231",
    transform: "translate(21.758 94.847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3627",
    "data-name": "Path 3627",
    d: "M367.587,138.161v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-353.173 -128.44)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3628",
    "data-name": "Path 3628",
    d: "M372.407,140.478v2.761L357.986,134.9v-2.753Z",
    transform: "translate(-357.986 -130.758)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3629",
    "data-name": "Path 3629",
    d: "M357.986,132.617l14.421,8.327,2.4-1.386-14.433-8.334Z",
    transform: "translate(-357.986 -131.223)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2232",
    "data-name": "Group 2232",
    transform: "translate(21.758 75.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3630",
    "data-name": "Path 3630",
    d: "M367.587,136.376v2.761l2.408-1.387V134.99Z",
    transform: "translate(-353.173 -110.247)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3631",
    "data-name": "Path 3631",
    d: "M372.407,144.174v2.761l-14.421-24.743v-2.753Z",
    transform: "translate(-357.986 -118.044)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3632",
    "data-name": "Path 3632",
    d: "M357.986,119.9l14.421,24.736,2.4-1.387-14.433-24.743Z",
    transform: "translate(-357.986 -118.509)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2233",
    "data-name": "Group 2233",
    transform: "translate(36.202 28.644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3633",
    "data-name": "Path 3633",
    d: "M369.194,89.437V400.286L371.6,398.9V88.051Z",
    transform: "translate(-366.812 -86.664)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3634",
    "data-name": "Path 3634",
    d: "M370,89.435V400.284l-2.388-1.386V88.056Z",
    transform: "translate(-367.607 -86.662)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3635",
    "data-name": "Path 3635",
    d: "M367.607,88.521,370,89.9l2.4-1.386L370,87.127Z",
    transform: "translate(-367.607 -87.127)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2234",
    "data-name": "Group 2234",
    transform: "translate(158.031 205.431)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3636",
    "data-name": "Path 3636",
    d: "M455.216,220.677v-11.4l1.779,1.1v11.4Z",
    transform: "translate(-445.514 -202.676)",
    fill: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3637",
    "data-name": "Path 3637",
    d: "M459.283,217.957l-1.779-1.088-6.852,3.9,1.794,1.1Z",
    transform: "translate(-447.802 -198.868)",
    fill: "#f0f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M0,28.343V7.978L13.874,0V20.365L0,28.342ZM9.6,7.394h0L4.277,10.45v10.5L9.6,17.891V7.394Z",
    transform: "translate(1.771 1.096)",
    fill: "#a8cff0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3640",
    "data-name": "Path 3640",
    d: "M450.533,211.286v20.366l-1.779-1.1V210.2Z",
    transform: "translate(-448.754 -202.213)",
    fill: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3641",
    "data-name": "Path 3641",
    d: "M448.754,212.865l1.779,1.088,13.866-7.977-1.794-1.1Z",
    transform: "translate(-448.754 -204.879)",
    fill: "#f0f8ff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2241",
    "data-name": "Group 2241",
    transform: "translate(709.285 180.691)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2238",
    "data-name": "Group 2238",
    transform: "translate(49.234 210.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3654",
    "data-name": "Path 3654",
    d: "M531.317,311.124l-37.462-21.947c-3.357-1.938-9.22-1.7-13.1.542l-48.917,18.818c-3.875,2.237-4.3,5.622-.94,7.561l17.934,10.415c3.531-2.558,8.974-4.2,15.1-4.186,10.687.02,19.376,5.037,19.409,11.206.02,3.561-2.859,6.721-7.342,8.759l10.637,6.178c3.357,1.937,9.22,1.7,13.1-.544l30.638-29.242C534.253,316.447,534.673,313.062,531.317,311.124Z",
    transform: "translate(-428.487 -279.929)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3655",
    "data-name": "Path 3655",
    d: "M533.442,307.364c-.291-.874-1.1,1.872-2.224,1.225l-37.461-21.947c-3.357-1.938-9.22-1.695-13.1.544L431.744,306c-2.093,1.209-3.178-1.342-3.205.126,0,.039,0,7.8,0,7.836a3.916,3.916,0,0,0,2.266,3.223l18.117,10.523v-7.768l-.05-.2.05-.035v-.025l.021.012c.065-.047.156-.11.225-.156,3.536-2.381,8.793-3.885,14.671-3.875,10.687.02,19.376,5.037,19.409,11.208.02,3.489-2.738,6.6-7.07,8.64v8.034l10.365,6.019c3.357,1.938,9.22,1.7,13.095-.542l30.64-29.242c2.151-1.242,3.238-2.837,3.205-4.342C533.477,315.132,533.538,307.655,533.442,307.364Z",
    transform: "translate(-428.537 -281.2)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3656",
    "data-name": "Path 3656",
    d: "M531.219,305.837l-37.462-21.948c-3.357-1.938-9.22-1.7-13.1.543l-48.917,18.816c-3.876,2.239-4.3,5.623-.94,7.561l17.934,10.415c3.531-2.558,8.974-4.2,15.1-4.186,10.687.02,19.376,5.037,19.409,11.208.02,3.561-2.859,6.72-7.342,8.757l10.637,6.178c3.357,1.938,9.22,1.7,13.095-.543l30.639-29.24C534.154,311.159,534.574,307.775,531.219,305.837Z",
    transform: "translate(-428.537 -282.58)",
    fill: "#c5c9f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2240",
    "data-name": "Group 2240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3660",
    "data-name": "Path 3660",
    d: "M588.79,428.138,412.1,326.043c-9.034-5.216-16.357-19.208-16.357-31.252V159.66c0-12.044,7.324-17.581,16.357-12.365L588.79,249.389c9.034,5.216,16.357,19.208,16.357,31.252V415.773C605.147,427.817,597.824,433.354,588.79,428.138Z",
    transform: "translate(-395.744 -140.961)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3661",
    "data-name": "Path 3661",
    d: "M587.829,415.209l-174.2-100.64c-7.27-4.62-11.766-13.851-11.766-23.3V155.252a2.9,2.9,0,0,1,4.367-2.5c.224.132.4.236.512.3l174.384,100.77c8.655,4.987,11.766,13.851,11.766,23.3V412.712a3.13,3.13,0,0,1-4.681,2.716C588.047,415.335,587.916,415.26,587.829,415.209Z",
    transform: "translate(-392.676 -137.441)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3662",
    "data-name": "Path 3662",
    d: "M581.127,253.823,406.742,153.053c-.11-.063-.288-.167-.512-.3a2.9,2.9,0,0,0-4.367,2.5V291.271c0,9.446,4.5,18.678,11.766,23.3l174.2,100.64c.087.051.218.126.383.219a3.13,3.13,0,0,0,4.681-2.716V277.121C592.893,267.675,589.782,258.811,581.127,253.823Zm9.928,158.889a1.3,1.3,0,0,1-1.3,1.294,1.273,1.273,0,0,1-.635-.174L414.548,312.978C407.984,308.8,403.7,300.269,403.7,291.27V155.252a1.068,1.068,0,0,1,1.069-1.063,1.049,1.049,0,0,1,.531.15L580.208,255.413c8.966,5.168,10.847,14.658,10.847,21.708Z",
    transform: "translate(-392.676 -137.441)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2239",
    "data-name": "Group 2239",
    transform: "translate(6.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3663",
    "data-name": "Path 3663",
    d: "M594.258,246.478,417.567,144.384c-3.573-2.063-6.879-2.444-9.571-1.405-.342.134-7.795,4.464-8.116,4.642l-.024.014c2.8-1.357,6.33-1.1,10.184,1.12L586.729,250.849c9.034,5.216,16.357,19.208,16.357,31.252V417.232c0,7.516-2.853,12.5-7.193,13.913a2.713,2.713,0,0,0,1.432-.488c.207-.12,8.05-4.821,8.247-4.959,3.108-2.175,5.041-6.646,5.041-12.838V277.73C610.614,265.685,603.29,251.694,594.258,246.478Z",
    transform: "translate(-399.856 -142.42)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3665",
    "data-name": "Path 3665",
    d: "M593.982,246.6,417.293,144.5c-3.575-2.063-6.881-2.444-9.571-1.405-.342.134-7.519,4.286-7.841,4.461l-.024.014c2.8-1.357,6.33-1.1,10.184,1.12L586.729,250.788C595.762,256,603.086,270,603.086,282.04V417.172c0,7.516-2.853,12.5-7.193,13.913a2.713,2.713,0,0,0,1.432-.488c.207-.12,7.774-4.639,7.972-4.777,3.106-2.176,5.042-6.646,5.042-12.838V277.851C610.339,265.806,603.015,251.815,593.982,246.6Z",
    transform: "translate(-399.856 -142.36)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3667",
    "data-name": "Path 3667",
    d: "M593.707,246.72,417.016,144.626c-3.573-2.063-6.879-2.444-9.571-1.405-.342.134-7.242,4.1-7.565,4.279l-.024.014c2.8-1.357,6.33-1.105,10.184,1.12L586.729,250.727c9.034,5.216,16.357,19.208,16.357,31.252V417.111c0,7.516-2.853,12.5-7.193,13.913a2.713,2.713,0,0,0,1.432-.488c.207-.12,7.5-4.458,7.7-4.6,3.108-2.175,5.042-6.646,5.042-12.838V277.972C610.063,265.927,602.739,251.936,593.707,246.72Z",
    transform: "translate(-399.856 -142.299)",
    fill: "#c5c9f6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3685",
    "data-name": "Path 3685",
    d: "M587.141,249.122,410.452,147.028c-3.705-2.139-7.11-2.444-9.852-1.26a12.082,12.082,0,0,1,7.89,1.848L585.179,249.711c9.034,5.216,16.356,19.207,16.356,31.252v135.13c0,7.106-2.56,11.921-6.5,13.625,5.046-.8,8.466-5.984,8.466-14.213V280.374C603.5,268.329,596.174,254.338,587.141,249.122Z",
    transform: "translate(-393.309 -141.086)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2374",
    "data-name": "Group 2374",
    transform: "translate(611.216 66.085)"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2282",
    "data-name": "Group 2282",
    transform: "translate(117.998 148.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3686",
    "data-name": "Path 3686",
    d: "M459.269,295.834l-50.251-29.013V191.609l50.251,29.013Z",
    transform: "translate(-409.017 -152.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2250",
    "data-name": "Group 2250",
    transform: "translate(59.469 75.395)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2242",
    "data-name": "Group 2242",
    transform: "translate(46.743 98.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3687",
    "data-name": "Path 3687",
    d: "M481.813,283.532l-1.863-1.075a.376.376,0,0,1,.375-.652l.737.426v-.851a.375.375,0,0,1,.751,0Z",
    transform: "translate(-479.762 -281.005)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2243",
    "data-name": "Group 2243",
    transform: "translate(3.973 74.477)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3688",
    "data-name": "Path 3688",
    d: "M491.746,288.958a.368.368,0,0,1-.188-.051l-2.672-1.543a.376.376,0,0,1,.375-.652l2.672,1.545a.376.376,0,0,1-.188.7Zm-5.345-3.087a.381.381,0,0,1-.188-.049l-2.674-1.545a.375.375,0,1,1,.375-.65l2.674,1.543a.376.376,0,0,1-.188.7Zm-5.348-3.088a.382.382,0,0,1-.188-.05l-2.672-1.542a.376.376,0,1,1,.375-.652l2.672,1.542a.376.376,0,0,1-.188.7Zm-5.345-3.085a.367.367,0,0,1-.188-.051l-2.672-1.542a.375.375,0,1,1,.375-.65L475.9,279a.375.375,0,0,1-.188.7Zm-5.348-3.087a.381.381,0,0,1-.188-.05l-2.672-1.545a.375.375,0,1,1,.375-.65l2.672,1.543a.375.375,0,0,1-.188.7Zm-5.345-3.087a.382.382,0,0,1-.188-.05l-2.674-1.543a.376.376,0,0,1,.375-.652l2.674,1.543a.376.376,0,0,1-.188.7Zm-5.346-3.087a.368.368,0,0,1-.188-.051l-2.674-1.542a.375.375,0,1,1,.375-.65l2.674,1.542a.376.376,0,0,1-.188.7Zm-5.346-3.087a.381.381,0,0,1-.188-.05l-2.674-1.543a.375.375,0,0,1,.375-.65l2.674,1.542a.376.376,0,0,1-.188.7Z",
    transform: "translate(-451.274 -265.057)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2244",
    "data-name": "Group 2244",
    transform: "translate(0 70.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3689",
    "data-name": "Path 3689",
    d: "M450.3,265.532a.366.366,0,0,1-.188-.05l-1.488-.859V262.9a.375.375,0,0,1,.751,0v1.285l1.112.642a.375.375,0,0,1-.188.7Z",
    transform: "translate(-448.628 -262.529)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2245",
    "data-name": "Group 2245",
    transform: "translate(0 4.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3690",
    "data-name": "Path 3690",
    d: "M449,282.293a.375.375,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.375.375,0,0,1,449,282.293Zm0-5.992a.375.375,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.376.376,0,0,1,449,276.3Zm0-5.99a.376.376,0,0,1-.375-.375v-3a.375.375,0,0,1,.751,0v3A.376.376,0,0,1,449,270.311Zm0-5.993a.375.375,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.376.376,0,0,1,449,264.318Zm0-5.992a.375.375,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.375.375,0,0,1,449,258.326Zm0-5.99a.375.375,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.375.375,0,0,1,449,252.335Zm0-5.992a.375.375,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.375.375,0,0,1,449,246.343Zm0-5.992a.376.376,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.376.376,0,0,1,449,240.352Zm0-5.992a.375.375,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.375.375,0,0,1,449,234.36Zm0-5.992a.375.375,0,0,1-.375-.375v-3a.375.375,0,0,1,.751,0v3A.375.375,0,0,1,449,228.368Zm0-5.992a.375.375,0,0,1-.375-.375v-3a.375.375,0,0,1,.751,0v3A.375.375,0,0,1,449,222.376Z",
    transform: "translate(-448.628 -218.63)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2246",
    "data-name": "Group 2246"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3691",
    "data-name": "Path 3691",
    d: "M449,217.978a.375.375,0,0,1-.375-.375v-2.151l1.863,1.075a.375.375,0,1,1-.375.65l-.737-.425v.851A.375.375,0,0,1,449,217.978Z",
    transform: "translate(-448.628 -215.451)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2247",
    "data-name": "Group 2247",
    transform: "translate(3.973 2.569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3692",
    "data-name": "Path 3692",
    d: "M491.746,241.062a.381.381,0,0,1-.188-.05l-2.672-1.543a.376.376,0,0,1,.375-.652l2.672,1.543a.375.375,0,0,1-.188.7Zm-5.345-3.087a.366.366,0,0,1-.188-.05l-2.672-1.543a.376.376,0,1,1,.375-.652l2.672,1.545a.375.375,0,0,1-.188.7Zm-5.348-3.087a.368.368,0,0,1-.188-.051l-2.672-1.542a.375.375,0,1,1,.375-.65l2.672,1.542a.376.376,0,0,1-.188.7Zm-5.345-3.087a.382.382,0,0,1-.188-.05l-2.672-1.543a.375.375,0,1,1,.375-.65L475.9,231.1a.376.376,0,0,1-.188.7Zm-5.346-3.087a.366.366,0,0,1-.188-.05l-2.674-1.543a.375.375,0,1,1,.375-.65l2.674,1.543a.375.375,0,0,1-.188.7Zm-5.346-3.085a.368.368,0,0,1-.188-.051l-2.674-1.543a.375.375,0,0,1,.375-.649l2.674,1.542a.375.375,0,0,1-.188.7Zm-5.346-3.087a.368.368,0,0,1-.188-.051l-2.674-1.543a.375.375,0,1,1,.375-.649l2.674,1.542a.376.376,0,0,1-.188.7Zm-5.346-3.087a.368.368,0,0,1-.188-.051l-2.674-1.543a.375.375,0,0,1,.375-.649l2.674,1.543a.375.375,0,0,1-.188.7Z",
    transform: "translate(-451.274 -217.162)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2248",
    "data-name": "Group 2248",
    transform: "translate(46.743 27.262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3693",
    "data-name": "Path 3693",
    d: "M481.437,236.612a.375.375,0,0,1-.375-.375v-1.284l-1.113-.643a.379.379,0,0,1-.138-.513.375.375,0,0,1,.513-.137l1.488.859v1.718A.376.376,0,0,1,481.437,236.612Z",
    transform: "translate(-479.762 -233.609)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2249",
    "data-name": "Group 2249",
    transform: "translate(48.043 32.509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3694",
    "data-name": "Path 3694",
    d: "M481,300.769a.375.375,0,0,1-.375-.375v-3a.375.375,0,0,1,.751,0v3A.375.375,0,0,1,481,300.769Zm0-5.99a.376.376,0,0,1-.375-.375v-3a.375.375,0,0,1,.751,0v3A.376.376,0,0,1,481,294.778Zm0-5.993a.375.375,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.375.375,0,0,1,481,288.785Zm0-5.992a.375.375,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.375.375,0,0,1,481,282.793Zm0-5.992a.375.375,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.375.375,0,0,1,481,276.8Zm0-5.99a.376.376,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.376.376,0,0,1,481,270.811Zm0-5.992a.376.376,0,0,1-.375-.375v-3a.375.375,0,0,1,.751,0v3A.376.376,0,0,1,481,264.819Zm0-5.993a.375.375,0,0,1-.375-.375v-3a.375.375,0,0,1,.751,0v3A.375.375,0,0,1,481,258.825Zm0-5.99a.375.375,0,0,1-.375-.375v-3a.375.375,0,0,1,.751,0v3A.376.376,0,0,1,481,252.835Zm0-5.992a.376.376,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.376.376,0,0,1,481,246.843Zm0-5.992a.376.376,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.376.376,0,0,1,481,240.851Z",
    transform: "translate(-480.628 -237.104)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2259",
    "data-name": "Group 2259",
    transform: "translate(117.273 109.256)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2251",
    "data-name": "Group 2251",
    transform: "translate(46.743 98.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3695",
    "data-name": "Path 3695",
    d: "M520.314,306.084l-1.863-1.075a.375.375,0,1,1,.375-.65l.737.426v-.851a.375.375,0,0,1,.751,0Z",
    transform: "translate(-518.263 -303.559)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2252",
    "data-name": "Group 2252",
    transform: "translate(3.973 74.477)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3696",
    "data-name": "Path 3696",
    d: "M530.246,311.511a.366.366,0,0,1-.188-.049l-2.672-1.543a.376.376,0,1,1,.375-.652l2.672,1.545a.374.374,0,0,1,.138.512A.378.378,0,0,1,530.246,311.511Zm-5.345-3.085a.369.369,0,0,1-.188-.051l-2.674-1.543a.376.376,0,1,1,.375-.652l2.674,1.545a.375.375,0,0,1-.188.7Zm-5.348-3.088a.381.381,0,0,1-.188-.049l-2.672-1.543a.375.375,0,1,1,.375-.65l2.672,1.542a.375.375,0,0,1-.188.7Zm-5.345-3.087a.366.366,0,0,1-.188-.049l-2.674-1.542a.376.376,0,0,1,.375-.652l2.674,1.543a.375.375,0,0,1-.188.7Zm-5.348-3.085a.368.368,0,0,1-.188-.051L506,297.571a.376.376,0,0,1,.375-.652l2.672,1.545a.376.376,0,0,1-.188.7Zm-5.345-3.087a.381.381,0,0,1-.188-.05l-2.674-1.543a.376.376,0,0,1,.375-.652l2.674,1.543a.376.376,0,0,1-.188.7Zm-5.346-3.088a.366.366,0,0,1-.188-.049l-2.674-1.542a.376.376,0,1,1,.375-.652l2.674,1.543a.375.375,0,0,1-.188.7Zm-5.346-3.085a.368.368,0,0,1-.188-.051l-2.674-1.542a.375.375,0,0,1,.375-.65l2.674,1.542a.376.376,0,0,1-.188.7Z",
    transform: "translate(-489.775 -287.611)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2253",
    "data-name": "Group 2253",
    transform: "translate(0 70.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3697",
    "data-name": "Path 3697",
    d: "M488.8,288.086a.382.382,0,0,1-.188-.049l-1.488-.859v-1.719a.375.375,0,0,1,.751,0v1.285l1.113.641a.375.375,0,0,1-.188.7Z",
    transform: "translate(-487.129 -285.083)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2254",
    "data-name": "Group 2254",
    transform: "translate(0 4.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3698",
    "data-name": "Path 3698",
    d: "M487.5,304.847a.375.375,0,0,1-.375-.375v-3a.375.375,0,0,1,.751,0v3A.376.376,0,0,1,487.5,304.847Zm0-5.992a.376.376,0,0,1-.375-.375v-3a.375.375,0,0,1,.751,0v3A.376.376,0,0,1,487.5,298.855Zm0-5.992a.375.375,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.376.376,0,0,1,487.5,292.863Zm0-5.992a.375.375,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.376.376,0,0,1,487.5,286.871Zm0-5.992a.375.375,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.375.375,0,0,1,487.5,280.88Zm0-5.99a.375.375,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.376.376,0,0,1,487.5,274.889Zm0-5.992a.376.376,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.376.376,0,0,1,487.5,268.9Zm0-5.993a.375.375,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.376.376,0,0,1,487.5,262.9Zm0-5.99a.375.375,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.376.376,0,0,1,487.5,256.914Zm0-5.992a.375.375,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.376.376,0,0,1,487.5,250.922Zm0-5.992a.376.376,0,0,1-.375-.375v-3a.375.375,0,0,1,.751,0v3A.376.376,0,0,1,487.5,244.93Z",
    transform: "translate(-487.129 -241.184)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2255",
    "data-name": "Group 2255"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3699",
    "data-name": "Path 3699",
    d: "M487.5,240.532a.376.376,0,0,1-.375-.375v-2.151l1.863,1.075a.375.375,0,1,1-.375.65l-.737-.426v.853A.377.377,0,0,1,487.5,240.532Z",
    transform: "translate(-487.129 -238.005)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2256",
    "data-name": "Group 2256",
    transform: "translate(3.973 2.569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3700",
    "data-name": "Path 3700",
    d: "M530.246,263.616a.381.381,0,0,1-.188-.05l-2.672-1.543a.375.375,0,1,1,.375-.65l2.672,1.542a.376.376,0,0,1-.188.7Zm-5.345-3.087a.381.381,0,0,1-.188-.05l-2.674-1.543a.376.376,0,1,1,.375-.652l2.674,1.543a.375.375,0,0,1-.188.7Zm-5.348-3.087a.366.366,0,0,1-.188-.05l-2.672-1.543a.376.376,0,0,1,.375-.652l2.672,1.545a.375.375,0,0,1-.188.7Zm-5.345-3.087a.381.381,0,0,1-.188-.05l-2.674-1.543a.375.375,0,0,1,.375-.65l2.674,1.542a.376.376,0,0,1-.188.7Zm-5.348-3.087a.382.382,0,0,1-.188-.049L506,249.677a.376.376,0,0,1,.375-.652l2.672,1.542a.376.376,0,0,1-.188.7Zm-5.345-3.087a.366.366,0,0,1-.188-.05l-2.674-1.543a.376.376,0,0,1,.375-.652l2.674,1.545a.375.375,0,0,1-.188.7ZM498.17,245.1a.381.381,0,0,1-.188-.05l-2.674-1.545a.375.375,0,1,1,.375-.65l2.674,1.543a.376.376,0,0,1-.188.7Zm-5.346-3.087a.381.381,0,0,1-.188-.05l-2.674-1.543a.376.376,0,0,1,.375-.652l2.674,1.543a.376.376,0,0,1-.188.7Z",
    transform: "translate(-489.775 -239.716)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2257",
    "data-name": "Group 2257",
    transform: "translate(46.743 27.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3701",
    "data-name": "Path 3701",
    d: "M519.939,259.166a.376.376,0,0,1-.375-.375v-1.284l-1.112-.643a.376.376,0,0,1,.375-.652l1.488.86v1.717A.375.375,0,0,1,519.939,259.166Z",
    transform: "translate(-518.263 -256.163)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2258",
    "data-name": "Group 2258",
    transform: "translate(48.043 32.509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3702",
    "data-name": "Path 3702",
    d: "M519.5,323.323a.376.376,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.376.376,0,0,1,519.5,323.323Zm0-5.992a.375.375,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.375.375,0,0,1,519.5,317.331Zm0-5.992a.375.375,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.375.375,0,0,1,519.5,311.339Zm0-5.992a.375.375,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.375.375,0,0,1,519.5,305.347Zm0-5.992a.376.376,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.376.376,0,0,1,519.5,299.355Zm0-5.992a.376.376,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.375.375,0,0,1,519.5,293.363Zm0-5.992a.375.375,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.375.375,0,0,1,519.5,287.371Zm0-5.992a.375.375,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.375.375,0,0,1,519.5,281.38Zm0-5.99a.376.376,0,0,1-.375-.375v-3a.375.375,0,0,1,.751,0v3A.376.376,0,0,1,519.5,275.389Zm0-5.992a.376.376,0,0,1-.375-.375v-3a.375.375,0,1,1,.751,0v3A.376.376,0,0,1,519.5,269.4Zm0-5.993a.376.376,0,0,1-.375-.375v-3a.375.375,0,0,1,.751,0v3A.375.375,0,0,1,519.5,263.4Z",
    transform: "translate(-519.129 -259.658)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2268",
    "data-name": "Group 2268",
    transform: "translate(0.243)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2260",
    "data-name": "Group 2260",
    transform: "translate(163.77 125.852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3703",
    "data-name": "Path 3703",
    d: "M520.315,251.583l-1.865-1.069a.374.374,0,0,1-.14-.51.37.37,0,0,1,.512-.14l.742.423v-.853a.375.375,0,1,1,.751,0Z",
    transform: "translate(-518.261 -249.059)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2261",
    "data-name": "Group 2261",
    transform: "translate(3.88 34.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3704",
    "data-name": "Path 3704",
    d: "M569.449,279.427a.38.38,0,0,1-.186-.05l-2.579-1.477a.375.375,0,0,1,.372-.652l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.159-2.956a.364.364,0,0,1-.186-.05l-2.578-1.476a.375.375,0,1,1,.372-.652l2.578,1.477a.374.374,0,0,1-.186.7Zm-5.157-2.953a.367.367,0,0,1-.186-.051l-2.579-1.477a.376.376,0,0,1-.14-.512.371.371,0,0,1,.512-.138l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.956a.38.38,0,0,1-.186-.05l-2.579-1.479a.372.372,0,0,1-.138-.51.368.368,0,0,1,.512-.14l2.578,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.956a.38.38,0,0,1-.186-.05l-2.579-1.477a.375.375,0,1,1,.372-.65l2.579,1.476a.375.375,0,0,1-.186.7Zm-5.159-2.955a.365.365,0,0,1-.186-.05l-2.579-1.477a.375.375,0,0,1,.372-.652l2.579,1.479a.374.374,0,0,1-.186.7ZM538.5,261.7a.367.367,0,0,1-.186-.051l-2.579-1.477a.376.376,0,0,1-.14-.512.371.371,0,0,1,.512-.14l2.579,1.479a.374.374,0,0,1,.138.512A.369.369,0,0,1,538.5,261.7Zm-5.159-2.956a.38.38,0,0,1-.186-.05l-2.579-1.477a.375.375,0,1,1,.372-.65l2.579,1.476a.375.375,0,0,1-.186.7Zm-5.157-2.955a.39.39,0,0,1-.188-.05l-2.578-1.477a.376.376,0,0,1-.14-.512.371.371,0,0,1,.512-.14l2.579,1.477a.376.376,0,0,1-.186.7Zm-5.157-2.956a.365.365,0,0,1-.186-.05l-2.579-1.477a.375.375,0,0,1,.372-.652l2.579,1.479a.374.374,0,0,1-.186.7Zm-5.159-2.953a.366.366,0,0,1-.186-.051l-2.578-1.477a.375.375,0,1,1,.372-.652l2.578,1.479a.375.375,0,0,1-.186.7Zm-5.157-2.956a.38.38,0,0,1-.186-.05l-2.579-1.479a.376.376,0,0,1-.14-.512.371.371,0,0,1,.512-.138l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.159-2.955a.366.366,0,0,1-.186-.051l-2.578-1.477a.375.375,0,1,1,.372-.652l2.578,1.479a.375.375,0,0,1-.186.7Zm-5.157-2.956a.38.38,0,0,1-.186-.05l-2.579-1.477a.376.376,0,0,1-.14-.512.372.372,0,0,1,.512-.14l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.159-2.955a.366.366,0,0,1-.186-.051l-2.578-1.477a.375.375,0,0,1,.372-.652l2.578,1.479a.375.375,0,0,1-.186.7Zm-5.156-2.956a.365.365,0,0,1-.186-.05l-2.579-1.477a.377.377,0,0,1-.14-.513.373.373,0,0,1,.512-.138l2.579,1.477a.376.376,0,0,1,.138.513A.371.371,0,0,1,492.085,235.1Zm-5.159-2.955a.366.366,0,0,1-.186-.051l-2.579-1.477a.372.372,0,0,1-.138-.51.368.368,0,0,1,.51-.14l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.956a.365.365,0,0,1-.186-.05L479,227.66a.377.377,0,0,1-.14-.513.373.373,0,0,1,.512-.138l2.579,1.479a.375.375,0,0,1-.186.7Zm-5.159-2.955a.38.38,0,0,1-.186-.05l-2.579-1.479a.375.375,0,1,1,.372-.65l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.159-2.956a.364.364,0,0,1-.186-.05l-2.578-1.477a.375.375,0,1,1,.372-.65l2.578,1.476a.375.375,0,0,1-.186.7Zm-5.157-2.955a.38.38,0,0,1-.186-.05l-2.578-1.477a.375.375,0,0,1,.372-.652l2.578,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.955a.381.381,0,0,1-.186-.05l-2.578-1.479a.375.375,0,1,1,.372-.65l2.578,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.955a.366.366,0,0,1-.186-.051l-2.579-1.477a.375.375,0,0,1,.372-.652l2.579,1.479a.375.375,0,0,1-.186.7Zm-5.159-2.956a.367.367,0,0,1-.186-.051l-2.579-1.476a.375.375,0,0,1,.372-.652l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.956a.365.365,0,0,1-.186-.05l-2.579-1.477a.375.375,0,1,1,.372-.652l2.579,1.479a.374.374,0,0,1,.138.512A.368.368,0,0,1,445.665,208.5Zm-5.159-2.955a.38.38,0,0,1-.186-.05l-2.579-1.477a.376.376,0,0,1-.138-.514.371.371,0,0,1,.51-.138l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.956a.364.364,0,0,1-.186-.05l-2.578-1.477a.375.375,0,0,1-.14-.512.372.372,0,0,1,.512-.138l2.578,1.477a.374.374,0,0,1,.138.512A.367.367,0,0,1,435.349,202.589Zm-5.157-2.955a.38.38,0,0,1-.186-.049l-2.579-1.477a.378.378,0,0,1-.14-.513.373.373,0,0,1,.512-.138l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.159-2.955a.384.384,0,0,1-.186-.05l-2.578-1.479a.375.375,0,1,1,.372-.65l2.579,1.477a.376.376,0,0,1-.188.7Zm-5.157-2.955a.366.366,0,0,1-.186-.051l-2.579-1.477a.375.375,0,1,1,.372-.652l2.579,1.479a.375.375,0,0,1-.186.7Zm-5.159-2.956a.38.38,0,0,1-.186-.05l-2.578-1.477a.375.375,0,0,1,.372-.652l2.578,1.477a.375.375,0,0,1-.186.7Z",
    transform: "translate(-411.764 -188.54)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2262",
    "data-name": "Group 2262",
    transform: "translate(0 31.269)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3705",
    "data-name": "Path 3705",
    d: "M410.857,189.058a.366.366,0,0,1-.186-.051l-1.492-.853v-1.719a.375.375,0,0,1,.751,0v1.284l1.114.638a.375.375,0,0,1-.186.7Z",
    transform: "translate(-409.179 -186.06)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2263",
    "data-name": "Group 2263",
    transform: "translate(0 5.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3706",
    "data-name": "Path 3706",
    d: "M409.554,192.288a.375.375,0,0,1-.375-.375v-3.277a.375.375,0,0,1,.751,0v3.277A.376.376,0,0,1,409.554,192.288Zm0-6.555a.375.375,0,0,1-.375-.375v-3.276a.375.375,0,0,1,.751,0v3.276A.376.376,0,0,1,409.554,185.733Zm0-6.555a.375.375,0,0,1-.375-.375v-3.276a.375.375,0,0,1,.751,0V178.8A.375.375,0,0,1,409.554,179.178Zm0-6.553a.375.375,0,0,1-.375-.375v-3.277a.375.375,0,0,1,.751,0v3.277A.376.376,0,0,1,409.554,172.625Z",
    transform: "translate(-409.179 -168.597)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2264",
    "data-name": "Group 2264"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3707",
    "data-name": "Path 3707",
    d: "M409.554,167.758a.375.375,0,0,1-.375-.375v-2.15l1.865,1.069a.375.375,0,1,1-.372.65l-.742-.423v.854A.376.376,0,0,1,409.554,167.758Z",
    transform: "translate(-409.179 -165.233)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2265",
    "data-name": "Group 2265",
    transform: "translate(3.88 2.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3708",
    "data-name": "Path 3708",
    d: "M569.449,257.782a.366.366,0,0,1-.186-.051l-2.579-1.477a.375.375,0,0,1,.372-.652l2.579,1.479a.375.375,0,0,1-.186.7Zm-5.159-2.956a.38.38,0,0,1-.186-.05l-2.578-1.477a.375.375,0,1,1,.372-.652l2.578,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.955a.367.367,0,0,1-.186-.051l-2.579-1.477a.375.375,0,1,1,.372-.652l2.579,1.479a.375.375,0,0,1-.186.7Zm-5.159-2.956a.365.365,0,0,1-.186-.05l-2.578-1.477a.376.376,0,0,1,.374-.652l2.576,1.479a.374.374,0,0,1-.186.7Zm-5.156-2.955a.38.38,0,0,1-.186-.05l-2.579-1.477a.378.378,0,0,1-.14-.513.373.373,0,0,1,.512-.138l2.579,1.477a.375.375,0,0,1-.186.7ZM543.661,243a.365.365,0,0,1-.186-.05l-2.579-1.477a.374.374,0,0,1-.138-.512.37.37,0,0,1,.51-.138l2.579,1.477a.374.374,0,0,1-.186.7Zm-5.157-2.955a.381.381,0,0,1-.186-.05l-2.579-1.477a.375.375,0,1,1,.372-.652l2.579,1.477a.376.376,0,0,1,.138.513A.371.371,0,0,1,538.5,240.049Zm-5.159-2.955a.38.38,0,0,1-.186-.05l-2.579-1.479a.375.375,0,0,1-.14-.512.371.371,0,0,1,.512-.138l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.956a.391.391,0,0,1-.188-.05l-2.578-1.477a.375.375,0,0,1,.372-.652l2.579,1.477a.376.376,0,0,1-.186.7Zm-5.159-2.955a.381.381,0,0,1-.186-.05l-2.578-1.477a.377.377,0,0,1-.14-.513.374.374,0,0,1,.512-.138l2.578,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.955a.366.366,0,0,1-.186-.051l-2.578-1.477a.375.375,0,1,1,.372-.652l2.578,1.479a.375.375,0,0,1-.186.7Zm-5.157-2.956a.365.365,0,0,1-.186-.05l-2.579-1.477a.375.375,0,1,1,.372-.652l2.579,1.479a.374.374,0,0,1-.186.7Zm-5.159-2.956a.364.364,0,0,1-.186-.05l-2.578-1.477a.375.375,0,1,1,.372-.65l2.578,1.477a.375.375,0,0,1,.14.512A.372.372,0,0,1,507.556,222.317Zm-5.157-2.955a.365.365,0,0,1-.186-.05l-2.579-1.477a.375.375,0,1,1,.372-.652l2.579,1.479a.374.374,0,0,1-.186.7Zm-5.159-2.955a.38.38,0,0,1-.186-.05l-2.579-1.479a.375.375,0,0,1,.372-.65l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.955a.38.38,0,0,1-.186-.05l-2.578-1.479a.375.375,0,1,1,.372-.65l2.578,1.477a.376.376,0,0,1-.186.7Zm-5.157-2.956a.38.38,0,0,1-.186-.05l-2.579-1.477a.375.375,0,0,1,.372-.652l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.955a.367.367,0,0,1-.186-.051L479,206.014a.375.375,0,1,1,.372-.65l2.579,1.477a.376.376,0,0,1-.186.7Zm-5.159-2.955a.367.367,0,0,1-.186-.051l-2.579-1.477a.375.375,0,0,1,.372-.652l2.579,1.479a.375.375,0,0,1-.186.7Zm-5.159-2.956a.38.38,0,0,1-.186-.05l-2.578-1.477a.378.378,0,0,1-.14-.513.373.373,0,0,1,.512-.138l2.578,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.955a.366.366,0,0,1-.186-.051l-2.579-1.477a.375.375,0,1,1,.372-.65l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.159-2.956a.38.38,0,0,1-.186-.05l-2.576-1.477a.375.375,0,1,1,.372-.652l2.576,1.477a.375.375,0,0,1-.186.7Zm-5.156-2.955a.38.38,0,0,1-.186-.05l-2.579-1.479a.375.375,0,1,1,.372-.65l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.159-2.956a.365.365,0,0,1-.186-.05l-2.579-1.477a.374.374,0,0,1-.138-.512.369.369,0,0,1,.51-.138l2.579,1.476a.375.375,0,0,1-.186.7Zm-5.157-2.955a.38.38,0,0,1-.186-.05l-2.579-1.477a.375.375,0,0,1-.14-.512.372.372,0,0,1,.512-.14l2.579,1.477a.374.374,0,0,1,.138.512A.369.369,0,0,1,445.665,186.855Zm-5.159-2.955a.38.38,0,0,1-.186-.05l-2.579-1.479a.375.375,0,0,1,.372-.652l2.579,1.479a.375.375,0,0,1-.186.7Zm-5.157-2.956a.365.365,0,0,1-.186-.05l-2.579-1.477a.376.376,0,0,1-.14-.512.371.371,0,0,1,.512-.14l2.579,1.479a.375.375,0,0,1-.186.7Zm-5.159-2.955a.38.38,0,0,1-.186-.05l-2.578-1.477a.378.378,0,0,1-.14-.513.372.372,0,0,1,.512-.138l2.578,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.956a.368.368,0,0,1-.186-.05l-2.578-1.477a.375.375,0,0,1-.14-.512.37.37,0,0,1,.512-.138l2.579,1.477a.375.375,0,0,1-.188.7Zm-5.157-2.955a.38.38,0,0,1-.186-.05l-2.579-1.477a.378.378,0,0,1-.14-.513.373.373,0,0,1,.512-.138l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.159-2.955a.38.38,0,0,1-.186-.05l-2.578-1.479a.375.375,0,1,1,.372-.65l2.578,1.477a.375.375,0,0,1-.186.7Z",
    transform: "translate(-411.764 -166.896)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2266",
    "data-name": "Group 2266",
    transform: "translate(163.77 94.108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3709",
    "data-name": "Path 3709",
    d: "M519.939,230.915a.375.375,0,0,1-.375-.375v-1.284l-1.114-.638a.375.375,0,0,1-.14-.512.371.371,0,0,1,.512-.14l1.492.856v1.718A.375.375,0,0,1,519.939,230.915Z",
    transform: "translate(-518.261 -227.915)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2267",
    "data-name": "Group 2267",
    transform: "translate(165.073 99.634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3710",
    "data-name": "Path 3710",
    d: "M519.5,255.286a.375.375,0,0,1-.375-.375v-3.277a.375.375,0,1,1,.751,0v3.277A.375.375,0,0,1,519.5,255.286Zm0-6.553a.376.376,0,0,1-.375-.375V245.08a.375.375,0,0,1,.751,0v3.277A.376.376,0,0,1,519.5,248.732Zm0-6.553a.376.376,0,0,1-.375-.375v-3.279a.375.375,0,1,1,.751,0V241.8A.376.376,0,0,1,519.5,242.179Zm0-6.556a.375.375,0,0,1-.375-.375v-3.276a.375.375,0,1,1,.751,0v3.276A.375.375,0,0,1,519.5,235.623Z",
    transform: "translate(-519.129 -231.596)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2277",
    "data-name": "Group 2277",
    transform: "translate(0.243 119.857)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2269",
    "data-name": "Group 2269",
    transform: "translate(163.77 105.636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3711",
    "data-name": "Path 3711",
    d: "M520.315,317.951l-1.865-1.068a.375.375,0,1,1,.372-.651l.742.423V315.8a.375.375,0,0,1,.751,0Z",
    transform: "translate(-518.261 -315.427)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2270",
    "data-name": "Group 2270",
    transform: "translate(3.88 14.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3712",
    "data-name": "Path 3712",
    d: "M569.449,345.795a.364.364,0,0,1-.186-.05l-2.579-1.477a.376.376,0,0,1-.14-.512.372.372,0,0,1,.512-.14l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.159-2.955a.367.367,0,0,1-.186-.051l-2.578-1.476a.375.375,0,1,1,.372-.652l2.578,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.955a.38.38,0,0,1-.186-.05l-2.579-1.479a.376.376,0,0,1-.14-.512.371.371,0,0,1,.512-.138l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.956a.381.381,0,0,1-.186-.049l-2.579-1.479a.375.375,0,0,1,.374-.65l2.578,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.956a.381.381,0,0,1-.186-.05l-2.579-1.476a.375.375,0,1,1,.372-.652l2.579,1.476a.375.375,0,0,1-.186.7Zm-5.159-2.955a.364.364,0,0,1-.186-.05l-2.579-1.477a.374.374,0,0,1-.138-.512.369.369,0,0,1,.51-.14l2.579,1.479a.374.374,0,0,1-.186.7Zm-5.157-2.955a.38.38,0,0,1-.186-.05l-2.579-1.479a.376.376,0,0,1-.14-.512.371.371,0,0,1,.512-.138l2.579,1.477a.374.374,0,0,1,.138.512A.369.369,0,0,1,538.5,328.064Zm-5.159-2.956a.38.38,0,0,1-.186-.05l-2.579-1.477a.375.375,0,1,1,.372-.65l2.579,1.476a.375.375,0,0,1-.186.7Zm-5.157-2.955a.374.374,0,0,1-.188-.05l-2.578-1.477a.375.375,0,0,1,.372-.652l2.579,1.477a.376.376,0,0,1-.186.7Zm-5.157-2.956a.365.365,0,0,1-.186-.05l-2.579-1.477a.376.376,0,0,1-.14-.512.372.372,0,0,1,.512-.14l2.579,1.479a.374.374,0,0,1,.14.51A.37.37,0,0,1,523.031,319.2Zm-5.159-2.953a.366.366,0,0,1-.186-.051l-2.578-1.477a.375.375,0,0,1,.372-.652l2.578,1.479a.375.375,0,0,1-.186.7Zm-5.157-2.956a.38.38,0,0,1-.186-.049l-2.579-1.479a.375.375,0,1,1,.372-.65l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.159-2.956a.364.364,0,0,1-.186-.05l-2.578-1.477a.375.375,0,0,1,.372-.652l2.578,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.955a.365.365,0,0,1-.186-.049l-2.579-1.477a.375.375,0,1,1,.372-.652l2.579,1.479a.374.374,0,0,1-.186.7Zm-5.159-2.955a.366.366,0,0,1-.186-.051l-2.578-1.477a.375.375,0,0,1,.372-.652l2.578,1.479a.375.375,0,0,1-.186.7Zm-5.156-2.956a.38.38,0,0,1-.186-.05l-2.579-1.477a.375.375,0,0,1-.14-.512.371.371,0,0,1,.512-.138l2.579,1.476a.374.374,0,0,1,.138.512A.369.369,0,0,1,492.085,301.466Zm-5.159-2.955a.38.38,0,0,1-.186-.049l-2.579-1.477a.375.375,0,0,1,.372-.652l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.956a.366.366,0,0,1-.186-.049L479,294.028a.375.375,0,1,1,.372-.652l2.579,1.479a.375.375,0,0,1-.186.7ZM476.61,292.6a.367.367,0,0,1-.186-.051l-2.579-1.476a.375.375,0,1,1,.372-.65L476.8,291.9a.375.375,0,0,1-.186.7Zm-5.159-2.955a.38.38,0,0,1-.186-.05l-2.578-1.479a.374.374,0,0,1-.14-.51.369.369,0,0,1,.512-.14l2.578,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.956a.38.38,0,0,1-.186-.05l-2.578-1.477a.375.375,0,0,1,.372-.652l2.578,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.956a.365.365,0,0,1-.186-.05l-2.578-1.476a.375.375,0,0,1,.372-.652l2.578,1.477a.374.374,0,0,1-.186.7Zm-5.157-2.953a.367.367,0,0,1-.186-.051l-2.579-1.477a.375.375,0,1,1,.372-.65l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.159-2.956a.38.38,0,0,1-.186-.05l-2.579-1.479a.372.372,0,0,1-.138-.51.368.368,0,0,1,.51-.14l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.956a.381.381,0,0,1-.186-.049l-2.579-1.477a.375.375,0,1,1,.372-.65l2.579,1.476a.374.374,0,0,1,.138.512A.369.369,0,0,1,445.665,274.868Zm-5.159-2.955a.364.364,0,0,1-.186-.049l-2.579-1.477a.375.375,0,0,1,.372-.652l2.579,1.479a.374.374,0,0,1-.186.7Zm-5.157-2.955a.366.366,0,0,1-.186-.051l-2.578-1.477a.375.375,0,1,1,.372-.652l2.578,1.479a.376.376,0,0,1-.186.7ZM430.192,266a.38.38,0,0,1-.186-.05l-2.579-1.479a.375.375,0,1,1,.372-.65l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.159-2.956a.384.384,0,0,1-.186-.05l-2.578-1.477a.376.376,0,0,1-.14-.512.372.372,0,0,1,.512-.14l2.579,1.477a.376.376,0,0,1-.188.7Zm-5.157-2.956a.364.364,0,0,1-.186-.049l-2.579-1.477a.375.375,0,1,1,.372-.652l2.579,1.479a.374.374,0,0,1-.186.7Zm-5.159-2.953a.367.367,0,0,1-.186-.051l-2.578-1.477a.375.375,0,1,1,.372-.652l2.578,1.479a.375.375,0,0,1-.186.7Z",
    transform: "translate(-411.764 -254.909)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2271",
    "data-name": "Group 2271",
    transform: "translate(0 11.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3713",
    "data-name": "Path 3713",
    d: "M410.857,255.426a.38.38,0,0,1-.186-.05l-1.492-.856V252.8a.375.375,0,0,1,.751,0v1.284l1.114.638a.375.375,0,0,1-.186.7Z",
    transform: "translate(-409.179 -252.428)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2272",
    "data-name": "Group 2272",
    transform: "translate(0 4.867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3714",
    "data-name": "Path 3714",
    d: "M409.554,252.151a.375.375,0,0,1-.375-.375v-3.093a.375.375,0,0,1,.751,0v3.093A.376.376,0,0,1,409.554,252.151Z",
    transform: "translate(-409.179 -248.308)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2273",
    "data-name": "Group 2273"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3715",
    "data-name": "Path 3715",
    d: "M409.554,247.591a.375.375,0,0,1-.375-.375v-2.15l1.865,1.069a.375.375,0,1,1-.372.652l-.742-.423v.853A.376.376,0,0,1,409.554,247.591Z",
    transform: "translate(-409.179 -245.066)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2274",
    "data-name": "Group 2274",
    transform: "translate(3.88 2.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3716",
    "data-name": "Path 3716",
    d: "M569.449,337.615a.366.366,0,0,1-.186-.051l-2.578-1.477a.376.376,0,0,1-.14-.512.372.372,0,0,1,.512-.138l2.578,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.956a.38.38,0,0,1-.186-.049l-2.578-1.477a.375.375,0,1,1,.372-.65l2.578,1.476a.375.375,0,0,1-.186.7Zm-5.157-2.955a.38.38,0,0,1-.186-.049l-2.579-1.479a.375.375,0,1,1,.372-.65L559.321,331a.375.375,0,0,1-.186.7Zm-5.159-2.956a.365.365,0,0,1-.186-.05l-2.579-1.477a.376.376,0,0,1,.374-.652l2.578,1.479a.374.374,0,0,1,.14.51A.37.37,0,0,1,553.976,328.748Zm-5.157-2.953a.366.366,0,0,1-.186-.051l-2.579-1.477a.375.375,0,1,1,.372-.652l2.579,1.479a.375.375,0,0,1-.186.7Zm-5.159-2.956a.381.381,0,0,1-.186-.05L540.9,321.31a.375.375,0,0,1,.372-.65l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.956a.381.381,0,0,1-.186-.05l-2.579-1.476a.375.375,0,1,1,.372-.652l2.579,1.476a.374.374,0,0,1,.138.512A.369.369,0,0,1,538.5,319.882Zm-5.159-2.955a.365.365,0,0,1-.186-.049l-2.578-1.477a.376.376,0,0,1-.14-.512.372.372,0,0,1,.512-.14l2.578,1.479a.374.374,0,0,1-.186.7Zm-5.157-2.955a.375.375,0,0,1-.186-.051l-2.578-1.477a.375.375,0,0,1,.372-.652l2.579,1.479a.376.376,0,0,1-.188.7Zm-5.157-2.955a.38.38,0,0,1-.186-.05l-2.579-1.479a.376.376,0,0,1-.14-.512.371.371,0,0,1,.512-.138l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.159-2.956a.379.379,0,0,1-.186-.05l-2.578-1.477a.375.375,0,1,1,.372-.652l2.578,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.956a.365.365,0,0,1-.186-.05l-2.579-1.476a.375.375,0,0,1,.372-.652l2.579,1.477a.374.374,0,0,1-.186.7Zm-5.159-2.953a.366.366,0,0,1-.186-.051l-2.578-1.477a.375.375,0,0,1,.372-.652l2.578,1.479a.375.375,0,0,1-.186.7ZM502.4,299.2a.38.38,0,0,1-.186-.05l-2.579-1.479a.376.376,0,0,1-.14-.512.371.371,0,0,1,.512-.138l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.955a.38.38,0,0,1-.186-.05l-2.579-1.479a.372.372,0,0,1-.138-.51.368.368,0,0,1,.51-.14l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.956a.38.38,0,0,1-.186-.05l-2.579-1.477a.375.375,0,1,1,.372-.652l2.579,1.477a.374.374,0,0,1,.138.512A.369.369,0,0,1,492.085,293.286Zm-5.159-2.955a.366.366,0,0,1-.186-.051l-2.579-1.476a.375.375,0,0,1,.372-.652l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.955a.38.38,0,0,1-.186-.05L479,285.848a.375.375,0,0,1-.14-.512.371.371,0,0,1,.512-.138l2.579,1.477a.376.376,0,0,1-.186.7Zm-5.159-2.956a.38.38,0,0,1-.186-.05l-2.579-1.479a.375.375,0,1,1,.372-.65l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.159-2.956a.38.38,0,0,1-.186-.05l-2.578-1.476a.375.375,0,1,1,.372-.652l2.578,1.476a.375.375,0,0,1-.186.7Zm-5.157-2.955a.365.365,0,0,1-.186-.05l-2.579-1.477a.375.375,0,1,1,.372-.652l2.579,1.479a.376.376,0,0,1,.14.512A.372.372,0,0,1,466.295,278.51Zm-5.157-2.955a.38.38,0,0,1-.186-.05l-2.578-1.479a.375.375,0,1,1,.372-.65l2.578,1.477a.375.375,0,0,1-.186.7ZM455.98,272.6a.38.38,0,0,1-.186-.05l-2.579-1.479a.375.375,0,1,1,.372-.65l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.159-2.956a.381.381,0,0,1-.186-.049l-2.579-1.477a.374.374,0,0,1-.138-.512.37.37,0,0,1,.51-.14l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.956a.364.364,0,0,1-.186-.05l-2.579-1.476a.375.375,0,1,1,.372-.652l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.159-2.953a.366.366,0,0,1-.186-.051l-2.579-1.477a.375.375,0,0,1,.372-.652l2.579,1.479a.375.375,0,0,1-.186.7Zm-5.157-2.956a.38.38,0,0,1-.186-.05l-2.579-1.479a.375.375,0,0,1-.14-.512.37.37,0,0,1,.512-.138l2.579,1.477a.374.374,0,0,1,.138.512A.369.369,0,0,1,435.349,260.779Zm-5.159-2.955a.38.38,0,0,1-.186-.05l-2.578-1.477a.375.375,0,1,1,.372-.652l2.578,1.477a.375.375,0,0,1-.186.7Zm-5.157-2.956a.369.369,0,0,1-.186-.049l-2.578-1.477a.376.376,0,0,1-.14-.512.371.371,0,0,1,.512-.14l2.579,1.479a.375.375,0,0,1-.188.7Zm-5.157-2.955a.366.366,0,0,1-.186-.051l-2.579-1.476a.375.375,0,1,1,.372-.652l2.579,1.477a.375.375,0,0,1-.186.7Zm-5.159-2.955a.38.38,0,0,1-.186-.05l-2.578-1.479a.375.375,0,1,1,.372-.65l2.578,1.477a.375.375,0,0,1-.186.7Z",
    transform: "translate(-411.764 -246.729)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2275",
    "data-name": "Group 2275",
    transform: "translate(163.77 94.108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3717",
    "data-name": "Path 3717",
    d: "M519.939,310.748a.375.375,0,0,1-.375-.375v-1.284l-1.114-.638a.375.375,0,0,1,.372-.652l1.492.856v1.718A.375.375,0,0,1,519.939,310.748Z",
    transform: "translate(-518.261 -307.748)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2276",
    "data-name": "Group 2276",
    transform: "translate(165.073 99.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3718",
    "data-name": "Path 3718",
    d: "M519.5,315.15a.375.375,0,0,1-.375-.375v-3.093a.375.375,0,1,1,.751,0v3.093A.375.375,0,0,1,519.5,315.15Z",
    transform: "translate(-519.129 -311.307)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3719",
    "data-name": "Path 3719",
    d: "M451.927,252.754,412.683,230.1V198.432l39.244,22.657Z",
    transform: "translate(-407.179 -148.589)",
    fill: "#7e7e7e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2279",
    "data-name": "Group 2279",
    transform: "translate(5.587 89.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2278",
    "data-name": "Group 2278"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3720",
    "data-name": "Path 3720",
    d: "M412.739,224.764v2.884l20.106,11.386v-2.884Z",
    transform: "translate(-412.739 -224.764)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3721",
    "data-name": "Path 3721",
    d: "M422.371,241.642l-9.632-5.484v1.582l9.632,5.484Z",
    transform: "translate(-412.739 -219.051)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3722",
    "data-name": "Path 3722",
    d: "M420.191,240.41v1.581l12.546,7.183v-1.581Z",
    transform: "translate(-409.003 -216.92)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3723",
    "data-name": "Path 3723",
    d: "M431.484,246.1v-1.581l-10.9-6.279v1.581Z",
    transform: "translate(-408.808 -218.006)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3724",
    "data-name": "Path 3724",
    d: "M428.584,240.41l-15.845-9.071v1.582l15.845,9.071Z",
    transform: "translate(-412.739 -221.467)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3725",
    "data-name": "Path 3725",
    d: "M422.371,234.468l-9.632-5.484v1.581l9.632,5.484Z",
    transform: "translate(-412.739 -222.648)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3726",
    "data-name": "Path 3726",
    d: "M420.191,233.235v1.581L432.737,242v-1.581Z",
    transform: "translate(-409.003 -220.517)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3727",
    "data-name": "Path 3727",
    d: "M424.329,237.979v1.581l7.658,4.552v-1.581Z",
    transform: "translate(-406.928 -218.138)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3728",
    "data-name": "Path 3728",
    d: "M429.585,240.2l14.3,8.478V247.1l-14.3-8.478Z",
    transform: "translate(-404.293 -217.818)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3729",
    "data-name": "Path 3729",
    d: "M430.467,243.191l12.974,7.522v-1.582l-12.974-7.522Z",
    transform: "translate(-403.851 -216.318)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3730",
    "data-name": "Path 3730",
    d: "M422.954,239.588l-10.216-5.821v1.582l10.216,5.821Z",
    transform: "translate(-412.739 -220.25)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3731",
    "data-name": "Path 3731",
    d: "M428.88,244.605l15.332,9.191v-1.581l-15.332-9.192Z",
    transform: "translate(-404.647 -215.609)",
    fill: "#afb6e5",
    opacity: 0.6
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3732",
    "data-name": "Path 3732",
    d: "M536.519,340.734l-50.251-29.013V236.509l50.251,29.013Z",
    transform: "translate(-370.288 -129.499)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3733",
    "data-name": "Path 3733",
    d: "M529.177,297.654,489.933,275V243.332l39.244,22.657Z",
    transform: "translate(-368.45 -126.078)",
    fill: "#16d696"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2281",
    "data-name": "Group 2281",
    transform: "translate(121.566 156.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2280",
    "data-name": "Group 2280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3734",
    "data-name": "Path 3734",
    d: "M489.989,269.664v2.884l20.106,11.386v-2.884Z",
    transform: "translate(-489.989 -269.664)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3735",
    "data-name": "Path 3735",
    d: "M499.621,286.542l-9.632-5.484v1.581l9.632,5.484Z",
    transform: "translate(-489.989 -263.951)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3736",
    "data-name": "Path 3736",
    d: "M497.441,285.31v1.581l12.546,7.183v-1.581Z",
    transform: "translate(-486.253 -261.82)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3737",
    "data-name": "Path 3737",
    d: "M508.734,291v-1.581l-10.9-6.279v1.581Z",
    transform: "translate(-486.058 -262.906)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3738",
    "data-name": "Path 3738",
    d: "M505.834,285.31l-15.845-9.071v1.582l15.845,9.071Z",
    transform: "translate(-489.989 -266.367)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3739",
    "data-name": "Path 3739",
    d: "M499.621,279.368l-9.632-5.484v1.581l9.632,5.484Z",
    transform: "translate(-489.989 -267.548)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3740",
    "data-name": "Path 3740",
    d: "M497.441,278.135v1.581l12.546,7.183v-1.581Z",
    transform: "translate(-486.253 -265.417)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3741",
    "data-name": "Path 3741",
    d: "M501.579,282.879v1.581l7.658,4.552v-1.581Z",
    transform: "translate(-484.178 -263.038)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3742",
    "data-name": "Path 3742",
    d: "M506.835,285.1l14.3,8.478V292l-14.3-8.478Z",
    transform: "translate(-481.543 -262.718)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3743",
    "data-name": "Path 3743",
    d: "M507.717,288.091l12.974,7.522v-1.582l-12.974-7.522Z",
    transform: "translate(-481.101 -261.218)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3744",
    "data-name": "Path 3744",
    d: "M500.2,284.488l-10.216-5.821v1.582L500.2,286.07Z",
    transform: "translate(-489.989 -265.15)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3745",
    "data-name": "Path 3745",
    d: "M506.13,289.505l15.332,9.191v-1.581l-15.332-9.192Z",
    transform: "translate(-481.897 -260.509)",
    fill: "#afb6e5",
    opacity: 0.6
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3746",
    "data-name": "Path 3746",
    d: "M500.435,240.208l-18.6-27.8c.089-.2-.123-.617-.362-.625-.077,0-.162-.033-.243-.045l-2.657-2.944a.507.507,0,0,0-.236-.054c-.02-.017-.02-.044-.042-.057l-.9-.042a4.286,4.286,0,0,1-.492-1.953,1.782,1.782,0,0,1,.932-1.811,4.366,4.366,0,0,0,.824-.3c.473-.147.857-.3.857-.806V201.28a1.643,1.643,0,0,0,.285-.177,1.676,1.676,0,0,0,.588-.26l.584-.359a2.241,2.241,0,0,0,1.314-2.356,6.973,6.973,0,0,0-.961-3.291l1.1-8.558,7.858-3.2-1-.56-7.86,3.2-1.071,7.748a6.224,6.224,0,0,0-1.54-1.32,2.408,2.408,0,0,0-2.506-.213l-.922.527,0,0-.107.06.011.018a1.842,1.842,0,0,0-.159.128,1.7,1.7,0,0,0-.559.216l-.634.362-1.209-12.481,7.8-3.174-1.04-.584-7.795,3.249,1.245,13.575c0,.1.022.21.03.315a3.109,3.109,0,0,0-.339,1.494,7.643,7.643,0,0,0,3.468,5.981,3.577,3.577,0,0,0,.953.378v.794a2,2,0,0,0-.982.273c-1.1.276-1.776,1.42-1.6,3.232a7.644,7.644,0,0,0,.6,2.226l-22.259,4.37-2.788-1.636-2.146,1.3V286.9l51.3,29.4,2.219-1.167V240.8Zm-45.8-26.257,20.884-4.5a8.5,8.5,0,0,0,2.384,2.773,3.119,3.119,0,0,0,3.034.632l16.877,25.84Z",
    transform: "translate(-271.536 -10.474)",
    fill: "#afb6e5",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2285",
    "data-name": "Group 2285",
    transform: "translate(176.55 201.591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3747",
    "data-name": "Path 3747",
    d: "M498.775,303.1,449.425,274.6V200.739l49.351,28.493Z",
    transform: "translate(-447.312 -200.168)",
    fill: "#0f001f",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3748",
    "data-name": "Path 3748",
    d: "M498.269,304.584l-50.251-29.013V200.359l50.251,29.013Z",
    transform: "translate(-448.017 -200.359)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3749",
    "data-name": "Path 3749",
    d: "M490.927,261.5l-39.244-22.657V207.182l39.244,22.657Z",
    transform: "translate(-446.179 -196.938)",
    fill: "#0d37c9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2284",
    "data-name": "Group 2284",
    transform: "translate(5.587 49.778)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2283",
    "data-name": "Group 2283"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3750",
    "data-name": "Path 3750",
    d: "M451.739,233.514V236.4l20.106,11.386V244.9Z",
    transform: "translate(-451.739 -233.514)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3751",
    "data-name": "Path 3751",
    d: "M461.371,250.392l-9.632-5.484v1.582l9.632,5.484Z",
    transform: "translate(-451.739 -227.801)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3752",
    "data-name": "Path 3752",
    d: "M459.191,249.16v1.581l12.546,7.183v-1.581Z",
    transform: "translate(-448.003 -225.67)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3753",
    "data-name": "Path 3753",
    d: "M470.484,254.853v-1.581l-10.9-6.279v1.581Z",
    transform: "translate(-447.808 -226.756)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3754",
    "data-name": "Path 3754",
    d: "M467.584,249.16l-15.845-9.071v1.582l15.845,9.071Z",
    transform: "translate(-451.739 -230.217)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3755",
    "data-name": "Path 3755",
    d: "M461.371,243.218l-9.632-5.484v1.581l9.632,5.484Z",
    transform: "translate(-451.739 -231.398)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3756",
    "data-name": "Path 3756",
    d: "M459.191,241.985v1.581l12.546,7.183v-1.581Z",
    transform: "translate(-448.003 -229.267)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3757",
    "data-name": "Path 3757",
    d: "M463.329,246.729v1.581l7.658,4.552v-1.581Z",
    transform: "translate(-445.928 -226.888)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3758",
    "data-name": "Path 3758",
    d: "M468.585,248.95l14.3,8.478v-1.581l-14.3-8.478Z",
    transform: "translate(-443.293 -226.568)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3759",
    "data-name": "Path 3759",
    d: "M469.468,251.941l12.974,7.522v-1.582l-12.974-7.522Z",
    transform: "translate(-442.851 -225.068)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3760",
    "data-name": "Path 3760",
    d: "M461.954,248.339l-10.216-5.821V244.1l10.216,5.821Z",
    transform: "translate(-451.739 -229)",
    fill: "#afb6e5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3761",
    "data-name": "Path 3761",
    d: "M467.88,253.355l15.332,9.191v-1.581l-15.332-9.191Z",
    transform: "translate(-443.647 -224.359)",
    fill: "#afb6e5",
    opacity: 0.6
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3762",
    "data-name": "Path 3762",
    d: "M488.625,231.875a.518.518,0,0,0,.359-.64l-23.3-33.37a.518.518,0,1,0-.479.919l22.776,32.734A.518.518,0,0,0,488.625,231.875Z",
    transform: "translate(-262.989 -0.048)",
    fill: "#5066e7"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2286",
    "data-name": "Group 2286",
    transform: "translate(177.226 129.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3763",
    "data-name": "Path 3763",
    d: "M448.486,204a.51.51,0,0,0,.628.354l24.368-5.2c.24.146.207-.443.353-.683a.508.508,0,0,0-.173-.7l-24.822,5.6A.509.509,0,0,0,448.486,204Z",
    transform: "translate(-448.467 -129.562)",
    fill: "#5066e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3764",
    "data-name": "Path 3764",
    d: "M470.249,192.9a7.638,7.638,0,0,0-3.468-5.981,2.408,2.408,0,0,0-2.506-.213l-1.033.59.679,1.15c0,.065-.009.128-.009.194a7.638,7.638,0,0,0,3.468,5.981c.089.051.176.095.264.138l.559.946.733-.449A2.241,2.241,0,0,0,470.249,192.9Z",
    transform: "translate(-441.06 -135.242)",
    fill: "#5066e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3765",
    "data-name": "Path 3765",
    d: "M469.573,193.274c0,2.2-1.552,3.084-3.467,1.977a7.638,7.638,0,0,1-3.468-5.981c0-2.2,1.552-3.082,3.468-1.977A7.643,7.643,0,0,1,469.573,193.274Z",
    transform: "translate(-441.363 -135.054)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3766",
    "data-name": "Path 3766",
    d: "M472.657,161.593a10.953,10.953,0,0,0-4.971-8.574,3.452,3.452,0,0,0-3.591-.306l-1.482.847.971,1.648c0,.093-.012.182-.012.278a10.949,10.949,0,0,0,4.971,8.574c.128.075.254.137.378.2l.8,1.357,1.051-.644C471.92,164.588,472.657,163.4,472.657,161.593Z",
    transform: "translate(-441.376 -152.339)",
    fill: "#5066e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3767",
    "data-name": "Path 3767",
    d: "M471.689,162.134c0,3.15-2.227,4.418-4.971,2.835a10.955,10.955,0,0,1-4.972-8.576c0-3.15,2.227-4.418,4.972-2.833A10.953,10.953,0,0,1,471.689,162.134Z",
    transform: "translate(-441.81 -152.069)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3768",
    "data-name": "Path 3768",
    d: "M468.053,212.638a3.757,3.757,0,0,1-1.877-.564,8.58,8.58,0,0,1-3.876-6.648l-1.818-47.54c-.015-.182-.024-.405-.024-.625,0-2.657,1.384-4.375,3.525-4.375a5.433,5.433,0,0,1,2.7.818,12.624,12.624,0,0,1,5.719,9.867q0,.331-.027.64l-1.815,45.446C470.55,211.457,469.565,212.638,468.053,212.638Zm-4.07-58.733c-1.546,0-2.506,1.287-2.506,3.355,0,.192.008.384.021.557l1.82,47.578a7.581,7.581,0,0,0,3.369,5.8,2.81,2.81,0,0,0,1.366.426c.925,0,1.483-.746,1.492-2l1.817-45.485c.016-.2.026-.378.026-.568a11.5,11.5,0,0,0-5.211-8.986A4.518,4.518,0,0,0,463.983,153.905Z",
    transform: "translate(-442.456 -152.065)",
    fill: "#5066e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3769",
    "data-name": "Path 3769",
    d: "M468.16,203.385a5.7,5.7,0,0,1-3.184-4.65c0-2.686,2.614-1.6,2.614-2.922V193l-1.961-1.131v3.009c-1.656-.282-2.8.964-2.585,3.271a8.947,8.947,0,0,0,3.432,5.921c1.356.961,2.591,1.055,3.4.464.2-.144-.062-.692-.332-.7A3.034,3.034,0,0,1,468.16,203.385Z",
    transform: "translate(-441.173 -132.522)",
    fill: "#5066e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3770",
    "data-name": "Path 3770",
    d: "M467.827,203.522a5.7,5.7,0,0,1-3.184-4.65c0-2.686,2.612-1.6,2.612-2.922v-2.817L465.3,192v3.01c-1.656-.282-2.8.964-2.587,3.271a8.947,8.947,0,0,0,3.432,5.921c1.357.961,2.593,1.055,3.4.464.2-.144-.062-.692-.33-.7A3.012,3.012,0,0,1,467.827,203.522Z",
    transform: "translate(-441.341 -132.454)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3771",
    "data-name": "Path 3771",
    d: "M471,162.5a10.953,10.953,0,0,0-4.971-8.574,3.454,3.454,0,0,0-3.593-.306l-1.482.847.973,1.648c0,.093-.012.182-.012.278a10.953,10.953,0,0,0,4.971,8.574c.128.074.252.135.378.2l.8,1.359,1.052-.644C470.258,165.5,471,164.312,471,162.5Z",
    transform: "translate(-442.21 -151.883)",
    fill: "#5066e7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_152",
    "data-name": "Ellipse 152",
    cx: 4.046,
    cy: 7.009,
    rx: 4.046,
    ry: 7.009,
    transform: "translate(15.381 4.552) rotate(-30.31)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3772",
    "data-name": "Path 3772",
    d: "M467.079,160.82c0,1.751-1.237,2.455-2.762,1.575a6.088,6.088,0,0,1-2.761-4.764c0-1.751,1.236-2.456,2.761-1.575A6.084,6.084,0,0,1,467.079,160.82Z",
    transform: "translate(-441.906 -150.666)",
    fill: "#5066e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3773",
    "data-name": "Path 3773",
    d: "M469.089,193.532a7.646,7.646,0,0,0-3.467-5.981,2.411,2.411,0,0,0-2.506-.213l-1.034.592.679,1.15c0,.065-.009.126-.009.194a7.643,7.643,0,0,0,3.468,5.981c.089.051.177.095.264.137l.558.947.734-.449A2.244,2.244,0,0,0,469.089,193.532Z",
    transform: "translate(-441.642 -134.924)",
    fill: "#5066e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3774",
    "data-name": "Path 3774",
    d: "M468.414,193.91c0,2.2-1.552,3.082-3.468,1.977a7.641,7.641,0,0,1-3.468-5.981c0-2.2,1.552-3.084,3.468-1.977A7.638,7.638,0,0,1,468.414,193.91Z",
    transform: "translate(-441.945 -134.736)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3775",
    "data-name": "Path 3775",
    d: "M466.358,192.358c0,1.221-.862,1.713-1.926,1.1a4.243,4.243,0,0,1-1.926-3.324c0-1.221.862-1.712,1.926-1.1A4.243,4.243,0,0,1,466.358,192.358Z",
    transform: "translate(-441.43 -134.074)",
    fill: "#5066e7"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2291",
    "data-name": "Group 2291",
    transform: "translate(3.117 16.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2287",
    "data-name": "Group 2287",
    transform: "translate(0 17.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3776",
    "data-name": "Path 3776",
    d: "M341.735,112.243l23.613-13.576V94.089l-23.613,13.577Z",
    transform: "translate(-327.868 -85.927)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3777",
    "data-name": "Path 3777",
    d: "M332.5,102.265l13.88,8.165v-4.577L332.5,97.705Z",
    transform: "translate(-332.499 -84.114)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3778",
    "data-name": "Path 3778",
    d: "M332.5,102.244l13.88,8.148,23.6-13.577-13.905-8.163Z",
    transform: "translate(-332.499 -88.652)",
    fill: "#afb6e5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2288",
    "data-name": "Group 2288",
    transform: "translate(0 11.547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3779",
    "data-name": "Path 3779",
    d: "M341.735,108.387l23.613-13.576V90.233L341.735,103.81Z",
    transform: "translate(-327.868 -82.07)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3780",
    "data-name": "Path 3780",
    d: "M332.5,98.409l13.88,8.165V102L332.5,93.849Z",
    transform: "translate(-332.499 -80.257)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3781",
    "data-name": "Path 3781",
    d: "M332.5,98.388l13.88,8.148,23.6-13.577L356.074,84.8Z",
    transform: "translate(-332.499 -84.796)",
    fill: "#afb6e5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2289",
    "data-name": "Group 2289",
    transform: "translate(0 5.902)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3782",
    "data-name": "Path 3782",
    d: "M341.735,104.626l23.613-13.576V86.473L341.735,100.05Z",
    transform: "translate(-327.868 -78.31)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3783",
    "data-name": "Path 3783",
    d: "M332.5,94.649l13.88,8.165V98.237L332.5,90.089Z",
    transform: "translate(-332.499 -76.497)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3784",
    "data-name": "Path 3784",
    d: "M332.5,94.627l13.88,8.148,23.6-13.577-13.905-8.163Z",
    transform: "translate(-332.499 -81.036)",
    fill: "#afb6e5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2290",
    "data-name": "Group 2290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3785",
    "data-name": "Path 3785",
    d: "M341.735,100.7l23.613-13.576V82.541L341.735,96.119Z",
    transform: "translate(-327.868 -74.379)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3786",
    "data-name": "Path 3786",
    d: "M332.5,90.717l13.88,8.165V94.306L332.5,86.158Z",
    transform: "translate(-332.499 -72.566)",
    fill: "#c5c9f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3787",
    "data-name": "Path 3787",
    d: "M332.5,90.7l13.88,8.148,23.6-13.577L356.074,77.1Z",
    transform: "translate(-332.499 -77.105)",
    fill: "#afb6e5"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2292",
    "data-name": "Group 2292",
    transform: "translate(41.382 43.643)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3788",
    "data-name": "Path 3788",
    d: "M360.394,102.092v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-357.986 -92.371)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3789",
    "data-name": "Path 3789",
    d: "M359.586,104.409v2.761l14.421-8.334V96.083Z",
    transform: "translate(-357.185 -94.689)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3790",
    "data-name": "Path 3790",
    d: "M374.808,96.548l-14.421,8.327-2.4-1.386,14.433-8.334Z",
    transform: "translate(-357.986 -95.154)",
    fill: "#e5e9ff"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2293",
    "data-name": "Group 2293",
    transform: "translate(58.125 43.643)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3791",
    "data-name": "Path 3791",
    d: "M378.739,102.092v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-364.325 -92.371)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3792",
    "data-name": "Path 3792",
    d: "M383.559,104.409v2.761l-14.421-8.334V96.083Z",
    transform: "translate(-369.138 -94.689)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3793",
    "data-name": "Path 3793",
    d: "M369.138,96.548l14.421,8.327,2.4-1.386-14.434-8.334Z",
    transform: "translate(-369.138 -95.154)",
    fill: "#e5e9ff"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2294",
    "data-name": "Group 2294",
    transform: "translate(58.125 53.484)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3794",
    "data-name": "Path 3794",
    d: "M371.546,108.647v2.761l-2.408-1.386V107.26Z",
    transform: "translate(-369.138 -98.926)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3795",
    "data-name": "Path 3795",
    d: "M370.738,110.964v2.761l14.421-8.334v-2.753Z",
    transform: "translate(-368.337 -101.244)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3796",
    "data-name": "Path 3796",
    d: "M385.96,103.1,371.54,111.43l-2.4-1.386,14.433-8.334Z",
    transform: "translate(-369.138 -101.709)",
    fill: "#e5e9ff"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2362",
    "data-name": "Group 2362",
    transform: "translate(0 0.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2295",
    "data-name": "Group 2295",
    transform: "translate(190.446 107.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3797",
    "data-name": "Path 3797",
    d: "M458.86,140.192v9.2l2.408-1.386v-9.2Z",
    transform: "translate(-456.478 -137.419)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3798",
    "data-name": "Path 3798",
    d: "M459.662,140.19v9.2l-2.388-1.386v-9.2Z",
    transform: "translate(-457.273 -137.417)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3799",
    "data-name": "Path 3799",
    d: "M457.273,139.276l2.388,1.379,2.4-1.386-2.4-1.386Z",
    transform: "translate(-457.273 -137.882)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2296",
    "data-name": "Group 2296",
    transform: "translate(154.693 101.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3800",
    "data-name": "Path 3800",
    d: "M435.866,138.736V141.5l-2.408-1.386V137.35Z",
    transform: "translate(-433.459 -132.626)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3801",
    "data-name": "Path 3801",
    d: "M435.058,139.848v2.761l7.859-4.724v-2.753Z",
    transform: "translate(-432.657 -133.738)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3802",
    "data-name": "Path 3802",
    d: "M443.719,135.6l-7.859,4.717-2.4-1.386,7.872-4.724Z",
    transform: "translate(-433.459 -134.203)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2297",
    "data-name": "Group 2297",
    transform: "translate(162.565 91.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3803",
    "data-name": "Path 3803",
    d: "M440.289,129.524v9.2l2.408-1.386v-9.2Z",
    transform: "translate(-437.907 -126.751)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3804",
    "data-name": "Path 3804",
    d: "M441.091,129.522v9.2l-2.389-1.386v-9.2Z",
    transform: "translate(-438.702 -126.749)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3805",
    "data-name": "Path 3805",
    d: "M438.7,128.608l2.389,1.379,2.4-1.386-2.4-1.386Z",
    transform: "translate(-438.702 -127.214)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2298",
    "data-name": "Group 2298",
    transform: "translate(168.592 109.536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3806",
    "data-name": "Path 3806",
    d: "M445.125,144.092v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-442.717 -137.981)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3807",
    "data-name": "Path 3807",
    d: "M444.316,145.2v2.761l7.859-4.724v-2.753Z",
    transform: "translate(-441.915 -139.093)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3808",
    "data-name": "Path 3808",
    d: "M452.977,140.952l-7.859,4.717-2.4-1.386,7.872-4.724Z",
    transform: "translate(-442.717 -139.559)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2299",
    "data-name": "Group 2299",
    transform: "translate(176.465 99.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3809",
    "data-name": "Path 3809",
    d: "M449.547,134.88v9.2l2.408-1.386v-9.2Z",
    transform: "translate(-447.165 -132.107)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3810",
    "data-name": "Path 3810",
    d: "M450.349,134.877v9.2l-2.388-1.386v-9.2Z",
    transform: "translate(-447.961 -132.104)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3811",
    "data-name": "Path 3811",
    d: "M447.961,133.964l2.388,1.379,2.4-1.386-2.4-1.386Z",
    transform: "translate(-447.961 -132.57)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2300",
    "data-name": "Group 2300",
    transform: "translate(2.325 13.474)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3812",
    "data-name": "Path 3812",
    d: "M334.379,80.107v2.761l-2.408-1.386V78.721Z",
    transform: "translate(-331.971 -73.997)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3813",
    "data-name": "Path 3813",
    d: "M333.571,81.22V83.98l7.859-4.724V76.5Z",
    transform: "translate(-331.169 -75.109)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3814",
    "data-name": "Path 3814",
    d: "M342.232,76.968l-7.859,4.717-2.4-1.386,7.872-4.724Z",
    transform: "translate(-331.971 -75.575)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2301",
    "data-name": "Group 2301",
    transform: "translate(10.197 2.879)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3815",
    "data-name": "Path 3815",
    d: "M338.8,70.827v9.2l2.408-1.386v-9.2Z",
    transform: "translate(-336.42 -68.054)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3816",
    "data-name": "Path 3816",
    d: "M339.6,70.825v9.2l-2.388-1.386v-9.2Z",
    transform: "translate(-337.215 -68.052)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3817",
    "data-name": "Path 3817",
    d: "M337.215,69.911,339.6,71.29,342,69.9l-2.4-1.386Z",
    transform: "translate(-337.215 -68.517)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2302",
    "data-name": "Group 2302",
    transform: "translate(9.965 11.89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3818",
    "data-name": "Path 3818",
    d: "M478.459,157.7v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-266.17 -33.512)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3819",
    "data-name": "Path 3819",
    d: "M549.355,198.243V201L337.06,78.2V75.448Z",
    transform: "translate(-337.06 -74.054)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3820",
    "data-name": "Path 3820",
    d: "M337.06,75.913l212.3,122.8,2.4-1.386L339.449,74.519Z",
    transform: "translate(-337.06 -74.519)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2303",
    "data-name": "Group 2303",
    transform: "translate(30.039 29.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3821",
    "data-name": "Path 3821",
    d: "M352.838,90.733v2.761l-2.408-1.386V89.347Z",
    transform: "translate(-350.431 -84.622)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3822",
    "data-name": "Path 3822",
    d: "M352.03,91.845v2.761l7.859-4.724V87.128Z",
    transform: "translate(-349.629 -85.735)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3823",
    "data-name": "Path 3823",
    d: "M360.691,87.594l-7.859,4.717-2.4-1.386L358.3,86.2Z",
    transform: "translate(-350.431 -86.2)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2304",
    "data-name": "Group 2304",
    transform: "translate(37.911 18.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3824",
    "data-name": "Path 3824",
    d: "M357.261,81.521v9.2l2.408-1.386v-9.2Z",
    transform: "translate(-354.879 -78.748)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3825",
    "data-name": "Path 3825",
    d: "M358.063,81.518v9.2l-2.389-1.386v-9.2Z",
    transform: "translate(-355.674 -78.746)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3826",
    "data-name": "Path 3826",
    d: "M355.674,80.6l2.389,1.379,2.4-1.386-2.4-1.387Z",
    transform: "translate(-355.674 -79.211)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2305",
    "data-name": "Group 2305",
    transform: "translate(204.428 115.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3827",
    "data-name": "Path 3827",
    d: "M468.172,145.63v9.2l2.408-1.386v-9.2Z",
    transform: "translate(-465.79 -142.857)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3828",
    "data-name": "Path 3828",
    d: "M468.974,145.627v9.2l-2.388-1.386v-9.2Z",
    transform: "translate(-466.586 -142.854)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3829",
    "data-name": "Path 3829",
    d: "M466.586,144.714l2.388,1.379,2.4-1.386-2.4-1.386Z",
    transform: "translate(-466.586 -143.32)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2306",
    "data-name": "Group 2306",
    transform: "translate(16.224 21.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3830",
    "data-name": "Path 3830",
    d: "M343.637,85.463v2.761l-2.408-1.386V84.077Z",
    transform: "translate(-341.229 -79.352)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3831",
    "data-name": "Path 3831",
    d: "M342.829,86.575v2.761l7.859-4.724V81.858Z",
    transform: "translate(-340.428 -80.465)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3832",
    "data-name": "Path 3832",
    d: "M351.49,82.324l-7.859,4.717-2.4-1.386L349.1,80.93Z",
    transform: "translate(-341.229 -80.93)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2307",
    "data-name": "Group 2307",
    transform: "translate(24.097 10.919)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3833",
    "data-name": "Path 3833",
    d: "M348.06,76.183v9.2L350.468,84V74.8Z",
    transform: "translate(-345.678 -73.41)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3834",
    "data-name": "Path 3834",
    d: "M348.862,76.18v9.2L346.473,84V74.8Z",
    transform: "translate(-346.473 -73.407)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3835",
    "data-name": "Path 3835",
    d: "M346.473,75.267l2.389,1.379,2.4-1.386-2.4-1.386Z",
    transform: "translate(-346.473 -73.873)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2308",
    "data-name": "Group 2308",
    transform: "translate(126.909 85.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3836",
    "data-name": "Path 3836",
    d: "M417.361,128.193v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-414.953 -122.083)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3837",
    "data-name": "Path 3837",
    d: "M416.552,129.305v2.761l7.859-4.724v-2.753Z",
    transform: "translate(-414.151 -123.195)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3838",
    "data-name": "Path 3838",
    d: "M425.214,125.054l-7.859,4.717-2.4-1.386,7.872-4.724Z",
    transform: "translate(-414.953 -123.66)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2309",
    "data-name": "Group 2309",
    transform: "translate(134.782 75.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3839",
    "data-name": "Path 3839",
    d: "M421.783,118.981v9.2l2.408-1.386v-9.2Z",
    transform: "translate(-419.401 -116.208)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3840",
    "data-name": "Path 3840",
    d: "M422.585,118.978v9.2L420.2,126.8v-9.2Z",
    transform: "translate(-420.197 -116.206)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3841",
    "data-name": "Path 3841",
    d: "M420.2,118.065l2.388,1.379,2.4-1.386-2.4-1.386Z",
    transform: "translate(-420.197 -116.671)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2310",
    "data-name": "Group 2310",
    transform: "translate(113.095 77.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3842",
    "data-name": "Path 3842",
    d: "M408.16,122.923v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-405.752 -116.812)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3843",
    "data-name": "Path 3843",
    d: "M407.351,124.035V126.8l7.859-4.724v-2.753Z",
    transform: "translate(-404.95 -117.925)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3844",
    "data-name": "Path 3844",
    d: "M416.012,119.784l-7.859,4.717-2.4-1.386,7.872-4.724Z",
    transform: "translate(-405.752 -118.39)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2311",
    "data-name": "Group 2311",
    transform: "translate(120.968 67.262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3845",
    "data-name": "Path 3845",
    d: "M412.582,113.711v9.2l2.408-1.386v-9.2Z",
    transform: "translate(-410.2 -110.938)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3846",
    "data-name": "Path 3846",
    d: "M413.384,113.708v9.2L411,121.525v-9.2Z",
    transform: "translate(-410.996 -110.936)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3847",
    "data-name": "Path 3847",
    d: "M411,112.795l2.389,1.379,2.4-1.386-2.4-1.386Z",
    transform: "translate(-410.996 -111.401)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2312",
    "data-name": "Group 2312",
    transform: "translate(99.195 69.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3848",
    "data-name": "Path 3848",
    d: "M398.9,117.567v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-396.494 -111.457)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3849",
    "data-name": "Path 3849",
    d: "M398.093,118.68v2.761l7.859-4.724v-2.753Z",
    transform: "translate(-395.692 -112.569)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3850",
    "data-name": "Path 3850",
    d: "M406.754,114.428l-7.859,4.717-2.4-1.386,7.872-4.724Z",
    transform: "translate(-396.494 -113.035)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2313",
    "data-name": "Group 2313",
    transform: "translate(107.068 59.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3851",
    "data-name": "Path 3851",
    d: "M403.324,108.355v9.2l2.408-1.386v-9.2Z",
    transform: "translate(-400.942 -105.583)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3852",
    "data-name": "Path 3852",
    d: "M404.126,108.353v9.2l-2.388-1.386v-9.2Z",
    transform: "translate(-401.737 -105.58)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3853",
    "data-name": "Path 3853",
    d: "M401.737,107.439l2.388,1.379,2.4-1.386-2.4-1.386Z",
    transform: "translate(-401.737 -106.046)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2314",
    "data-name": "Group 2314",
    transform: "translate(85.381 61.589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3854",
    "data-name": "Path 3854",
    d: "M389.7,112.155v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-387.292 -106.045)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3855",
    "data-name": "Path 3855",
    d: "M388.892,113.267v2.761l7.859-4.724V108.55Z",
    transform: "translate(-386.49 -107.157)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3856",
    "data-name": "Path 3856",
    d: "M397.553,109.016l-7.859,4.717-2.4-1.386,7.872-4.724Z",
    transform: "translate(-387.292 -107.622)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2315",
    "data-name": "Group 2315",
    transform: "translate(93.254 51.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3857",
    "data-name": "Path 3857",
    d: "M394.123,102.943v9.2l2.408-1.386v-9.2Z",
    transform: "translate(-391.741 -100.17)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3858",
    "data-name": "Path 3858",
    d: "M394.925,102.94v9.2l-2.388-1.386v-9.2Z",
    transform: "translate(-392.536 -100.168)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    d: "M392.536,102.027l2.388,1.379,2.4-1.386-2.4-1.386Z",
    transform: "translate(-392.536 -100.633)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2316",
    "data-name": "Group 2316",
    transform: "translate(71.481 53.548)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    d: "M380.442,106.8v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-378.034 -100.689)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    "data-name": "Path 3861",
    d: "M379.634,107.912v2.761l7.859-4.724v-2.753Z",
    transform: "translate(-377.232 -101.801)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    "data-name": "Path 3862",
    d: "M388.295,103.66l-7.859,4.717-2.4-1.386,7.872-4.724Z",
    transform: "translate(-378.034 -102.267)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2317",
    "data-name": "Group 2317",
    transform: "translate(79.354 43.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3863",
    "data-name": "Path 3863",
    d: "M384.865,97.587v9.2l2.408-1.386V96.2Z",
    transform: "translate(-382.483 -94.815)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3864",
    "data-name": "Path 3864",
    d: "M385.667,97.585v9.2l-2.389-1.386v-9.2Z",
    transform: "translate(-383.278 -94.812)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3865",
    "data-name": "Path 3865",
    d: "M383.278,96.671l2.389,1.379,2.4-1.386-2.4-1.386Z",
    transform: "translate(-383.278 -95.278)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2318",
    "data-name": "Group 2318",
    transform: "translate(57.667 45.636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3866",
    "data-name": "Path 3866",
    d: "M371.241,101.529v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-368.833 -95.419)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3867",
    "data-name": "Path 3867",
    d: "M370.432,102.642V105.4l7.859-4.724V97.925Z",
    transform: "translate(-368.031 -96.531)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3868",
    "data-name": "Path 3868",
    d: "M379.094,98.39l-7.859,4.717-2.4-1.386L376.7,97Z",
    transform: "translate(-368.833 -96.996)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2319",
    "data-name": "Group 2319",
    transform: "translate(65.54 35.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3869",
    "data-name": "Path 3869",
    d: "M375.663,92.317v9.2l2.408-1.386v-9.2Z",
    transform: "translate(-373.281 -89.545)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3870",
    "data-name": "Path 3870",
    d: "M376.465,92.315v9.2l-2.389-1.386v-9.2Z",
    transform: "translate(-374.077 -89.542)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3871",
    "data-name": "Path 3871",
    d: "M374.077,91.4l2.389,1.379,2.4-1.386-2.4-1.386Z",
    transform: "translate(-374.077 -90.008)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2320",
    "data-name": "Group 2320",
    transform: "translate(43.767 37.595)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3872",
    "data-name": "Path 3872",
    d: "M361.983,96.174v2.761l-2.408-1.386V94.788Z",
    transform: "translate(-359.575 -90.063)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3873",
    "data-name": "Path 3873",
    d: "M361.174,97.286v2.761l7.859-4.724V92.569Z",
    transform: "translate(-358.773 -91.176)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3874",
    "data-name": "Path 3874",
    d: "M369.835,93.035l-7.859,4.717-2.4-1.386,7.872-4.724Z",
    transform: "translate(-359.575 -91.641)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2321",
    "data-name": "Group 2321",
    transform: "translate(51.64 27.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3875",
    "data-name": "Path 3875",
    d: "M366.405,86.962v9.2l2.408-1.386v-9.2Z",
    transform: "translate(-364.023 -84.189)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3876",
    "data-name": "Path 3876",
    d: "M367.207,86.96v9.2l-2.389-1.386v-9.2Z",
    transform: "translate(-364.819 -84.187)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3877",
    "data-name": "Path 3877",
    d: "M364.819,86.046l2.389,1.379,2.4-1.387-2.4-1.386Z",
    transform: "translate(-364.819 -84.652)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2322",
    "data-name": "Group 2322",
    transform: "translate(140.809 93.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3878",
    "data-name": "Path 3878",
    d: "M426.619,133.549v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-424.211 -127.438)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3879",
    "data-name": "Path 3879",
    d: "M425.811,134.661v2.761l7.859-4.724v-2.753Z",
    transform: "translate(-423.409 -128.55)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3880",
    "data-name": "Path 3880",
    d: "M434.472,130.409l-7.859,4.717-2.4-1.387,7.872-4.724Z",
    transform: "translate(-424.211 -129.016)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2323",
    "data-name": "Group 2323",
    transform: "translate(0 18.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3881",
    "data-name": "Path 3881",
    d: "M471.708,161.717v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-259.59 -37.699)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3882",
    "data-name": "Path 3882",
    d: "M542.547,202.2v2.761L330.423,82.332V79.578Z",
    transform: "translate(-330.423 -78.184)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3883",
    "data-name": "Path 3883",
    d: "M330.423,80.044,542.547,202.668l2.4-1.386L332.811,78.65Z",
    transform: "translate(-330.423 -78.65)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2324",
    "data-name": "Group 2324",
    transform: "translate(148.682 83.215)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3884",
    "data-name": "Path 3884",
    d: "M431.042,124.336v9.2l2.408-1.386v-9.2Z",
    transform: "translate(-428.66 -121.564)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3885",
    "data-name": "Path 3885",
    d: "M431.843,124.334v9.2l-2.389-1.386v-9.2Z",
    transform: "translate(-429.455 -121.561)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3886",
    "data-name": "Path 3886",
    d: "M429.455,123.42l2.389,1.379,2.4-1.386-2.4-1.386Z",
    transform: "translate(-429.455 -122.027)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2325",
    "data-name": "Group 2325",
    transform: "translate(10.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3887",
    "data-name": "Path 3887",
    d: "M471.195,145.565v2.761l2.408-1.386v-2.761Z",
    transform: "translate(-269.983 -27.706)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3888",
    "data-name": "Path 3888",
    d: "M538.392,183.994v2.761L337.174,70.282V67.528Z",
    transform: "translate(-337.174 -66.134)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3889",
    "data-name": "Path 3889",
    d: "M337.174,67.994,538.392,184.459l2.4-1.386L339.563,66.6Z",
    transform: "translate(-337.174 -66.6)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2326",
    "data-name": "Group 2326",
    transform: "translate(211.989 134.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3890",
    "data-name": "Path 3890",
    d: "M474.03,160.806v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-471.622 -154.695)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3891",
    "data-name": "Path 3891",
    d: "M473.222,161.918v2.761l7.859-4.724V157.2Z",
    transform: "translate(-470.82 -155.807)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3892",
    "data-name": "Path 3892",
    d: "M481.883,157.666l-7.859,4.717-2.4-1.386,7.872-4.724Z",
    transform: "translate(-471.622 -156.273)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2327",
    "data-name": "Group 2327",
    transform: "translate(208.934 116.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3893",
    "data-name": "Path 3893",
    d: "M471.173,145.588l10.939,18.176,2.408-1.386L473.581,144.2Z",
    transform: "translate(-468.791 -144.202)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3894",
    "data-name": "Path 3894",
    d: "M471.976,145.585l10.939,18.176-2.388-1.386-10.939-18.169Z",
    transform: "translate(-469.587 -144.199)",
    fill: "#ced3f4"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1125",
    "data-name": "Rectangle 1125",
    width: 1.122,
    height: 217.575,
    transform: "translate(15.854 22.921) rotate(-59.935)",
    fill: "#5066e7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2328",
    "data-name": "Group 2328",
    transform: "translate(138.513 89.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3895",
    "data-name": "Path 3895",
    d: "M424.269,128.332v9.2l2.408-1.386v-9.2Z",
    transform: "translate(-421.887 -125.559)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3896",
    "data-name": "Path 3896",
    d: "M425.071,128.329v9.2l-2.389-1.386v-9.2Z",
    transform: "translate(-422.682 -125.556)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3897",
    "data-name": "Path 3897",
    d: "M422.682,127.416l2.389,1.379,2.4-1.386-2.4-1.387Z",
    transform: "translate(-422.682 -126.022)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2329",
    "data-name": "Group 2329",
    transform: "translate(140.809 81.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3898",
    "data-name": "Path 3898",
    d: "M426.619,125.643V128.4l-2.408-1.386v-2.761Z",
    transform: "translate(-424.211 -119.533)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3899",
    "data-name": "Path 3899",
    d: "M425.811,126.756v2.761l7.859-4.724v-2.753Z",
    transform: "translate(-423.409 -120.645)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3900",
    "data-name": "Path 3900",
    d: "M434.472,122.5l-7.859,4.717-2.4-1.386,7.872-4.724Z",
    transform: "translate(-424.211 -121.11)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2330",
    "data-name": "Group 2330",
    transform: "translate(124.614 81.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3901",
    "data-name": "Path 3901",
    d: "M415.011,122.976v9.2l2.408-1.387v-9.2Z",
    transform: "translate(-412.629 -120.203)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3902",
    "data-name": "Path 3902",
    d: "M415.813,122.974v9.2l-2.389-1.387v-9.2Z",
    transform: "translate(-413.424 -120.201)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3903",
    "data-name": "Path 3903",
    d: "M413.424,122.06l2.389,1.379,2.4-1.386-2.4-1.386Z",
    transform: "translate(-413.424 -120.666)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2331",
    "data-name": "Group 2331",
    transform: "translate(126.909 73.799)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3904",
    "data-name": "Path 3904",
    d: "M417.361,120.288v2.761l-2.408-1.386V118.9Z",
    transform: "translate(-414.953 -114.177)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3905",
    "data-name": "Path 3905",
    d: "M416.552,121.4v2.761l7.859-4.724v-2.753Z",
    transform: "translate(-414.151 -115.29)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3906",
    "data-name": "Path 3906",
    d: "M425.214,117.149l-7.859,4.717-2.4-1.386,7.872-4.724Z",
    transform: "translate(-414.953 -115.755)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2332",
    "data-name": "Group 2332",
    transform: "translate(110.799 73.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3907",
    "data-name": "Path 3907",
    d: "M405.809,117.706v9.2l2.408-1.386v-9.2Z",
    transform: "translate(-403.427 -114.933)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3908",
    "data-name": "Path 3908",
    d: "M406.611,117.7v9.2l-2.389-1.386v-9.2Z",
    transform: "translate(-404.223 -114.931)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3909",
    "data-name": "Path 3909",
    d: "M404.223,116.79l2.389,1.379,2.4-1.387-2.4-1.386Z",
    transform: "translate(-404.223 -115.396)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2333",
    "data-name": "Group 2333",
    transform: "translate(166.297 105.042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3910",
    "data-name": "Path 3910",
    d: "M442.774,138.875v9.2l2.408-1.386v-9.2Z",
    transform: "translate(-440.392 -136.102)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3911",
    "data-name": "Path 3911",
    d: "M443.576,138.872v9.2l-2.388-1.386v-9.2Z",
    transform: "translate(-441.188 -136.1)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3912",
    "data-name": "Path 3912",
    d: "M441.188,137.959l2.388,1.379,2.4-1.386-2.4-1.386Z",
    transform: "translate(-441.188 -136.565)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2334",
    "data-name": "Group 2334",
    transform: "translate(168.592 97.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3913",
    "data-name": "Path 3913",
    d: "M445.125,136.186v2.761l-2.408-1.386V134.8Z",
    transform: "translate(-442.717 -130.076)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3914",
    "data-name": "Path 3914",
    d: "M444.316,137.3v2.761l7.859-4.724v-2.753Z",
    transform: "translate(-441.915 -131.188)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3915",
    "data-name": "Path 3915",
    d: "M452.977,133.047l-7.859,4.717-2.4-1.386,7.872-4.724Z",
    transform: "translate(-442.717 -131.654)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2335",
    "data-name": "Group 2335",
    transform: "translate(152.397 97.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3916",
    "data-name": "Path 3916",
    d: "M433.516,133.519v9.2l2.408-1.386v-9.2Z",
    transform: "translate(-431.134 -130.747)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3917",
    "data-name": "Path 3917",
    d: "M434.318,133.517v9.2l-2.388-1.386v-9.2Z",
    transform: "translate(-431.93 -130.744)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3918",
    "data-name": "Path 3918",
    d: "M431.93,132.6l2.388,1.379,2.4-1.386-2.4-1.386Z",
    transform: "translate(-431.93 -131.21)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2336",
    "data-name": "Group 2336",
    transform: "translate(154.693 89.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3919",
    "data-name": "Path 3919",
    d: "M435.866,130.831v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-433.459 -124.72)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3920",
    "data-name": "Path 3920",
    d: "M435.058,131.943V134.7l7.859-4.724v-2.753Z",
    transform: "translate(-432.657 -125.833)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3921",
    "data-name": "Path 3921",
    d: "M443.719,127.692l-7.859,4.717-2.4-1.386,7.872-4.724Z",
    transform: "translate(-433.459 -126.298)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2337",
    "data-name": "Group 2337",
    transform: "translate(182.573 117.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3922",
    "data-name": "Path 3922",
    d: "M454.437,149.4v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-452.029 -143.294)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3923",
    "data-name": "Path 3923",
    d: "M453.629,150.516v2.761l7.859-4.724V145.8Z",
    transform: "translate(-451.227 -144.406)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3924",
    "data-name": "Path 3924",
    d: "M462.29,146.265l-7.859,4.717-2.4-1.386,7.872-4.724Z",
    transform: "translate(-452.029 -144.871)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2338",
    "data-name": "Group 2338",
    transform: "translate(180.278 113.018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3925",
    "data-name": "Path 3925",
    d: "M452.087,144.187v9.2L454.495,152v-9.2Z",
    transform: "translate(-449.705 -141.415)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3926",
    "data-name": "Path 3926",
    d: "M452.889,144.185v9.2L450.5,152v-9.2Z",
    transform: "translate(-450.5 -141.412)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3927",
    "data-name": "Path 3927",
    d: "M450.5,143.271l2.388,1.379,2.4-1.386-2.4-1.386Z",
    transform: "translate(-450.5 -141.877)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2339",
    "data-name": "Group 2339",
    transform: "translate(182.573 105.644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3928",
    "data-name": "Path 3928",
    d: "M454.437,141.5v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-452.029 -135.389)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3929",
    "data-name": "Path 3929",
    d: "M453.629,142.611v2.761l7.859-4.724v-2.753Z",
    transform: "translate(-451.227 -136.501)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3930",
    "data-name": "Path 3930",
    d: "M462.29,138.36l-7.859,4.717-2.4-1.386,7.872-4.724Z",
    transform: "translate(-452.029 -136.966)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2340",
    "data-name": "Group 2340",
    transform: "translate(196.555 125.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3931",
    "data-name": "Path 3931",
    d: "M463.75,154.842V157.6l-2.408-1.386v-2.761Z",
    transform: "translate(-461.342 -148.731)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3932",
    "data-name": "Path 3932",
    d: "M462.941,155.954v2.761l7.859-4.724v-2.753Z",
    transform: "translate(-460.54 -149.843)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3933",
    "data-name": "Path 3933",
    d: "M471.6,151.7l-7.859,4.717-2.4-1.386,7.872-4.724Z",
    transform: "translate(-461.342 -150.309)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2341",
    "data-name": "Group 2341",
    transform: "translate(194.259 121.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3934",
    "data-name": "Path 3934",
    d: "M461.4,149.625v9.2l2.408-1.386v-9.2Z",
    transform: "translate(-459.017 -146.852)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3935",
    "data-name": "Path 3935",
    d: "M462.2,149.622v9.2l-2.389-1.386v-9.2Z",
    transform: "translate(-459.813 -146.85)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3936",
    "data-name": "Path 3936",
    d: "M459.813,148.709l2.389,1.379,2.4-1.386-2.4-1.386Z",
    transform: "translate(-459.813 -147.315)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2342",
    "data-name": "Group 2342",
    transform: "translate(196.555 113.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3937",
    "data-name": "Path 3937",
    d: "M463.75,146.936V149.7l-2.408-1.386V145.55Z",
    transform: "translate(-461.342 -140.826)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3938",
    "data-name": "Path 3938",
    d: "M462.941,148.049v2.761l7.859-4.724v-2.753Z",
    transform: "translate(-460.54 -141.938)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3939",
    "data-name": "Path 3939",
    d: "M471.6,143.8l-7.859,4.717-2.4-1.386,7.872-4.724Z",
    transform: "translate(-461.342 -142.404)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2343",
    "data-name": "Group 2343",
    transform: "translate(113.095 65.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3940",
    "data-name": "Path 3940",
    d: "M408.16,115.018v2.761l-2.408-1.387v-2.761Z",
    transform: "translate(-405.752 -108.908)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3941",
    "data-name": "Path 3941",
    d: "M407.351,116.13v2.761l7.859-4.724v-2.753Z",
    transform: "translate(-404.95 -110.02)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3942",
    "data-name": "Path 3942",
    d: "M416.012,111.879l-7.859,4.717-2.4-1.386,7.872-4.724Z",
    transform: "translate(-405.752 -110.485)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2344",
    "data-name": "Group 2344",
    transform: "translate(96.9 65.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3943",
    "data-name": "Path 3943",
    d: "M396.551,112.351v9.2l2.408-1.386v-9.2Z",
    transform: "translate(-394.169 -109.578)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3944",
    "data-name": "Path 3944",
    d: "M397.353,112.348v9.2l-2.389-1.386v-9.2Z",
    transform: "translate(-394.965 -109.576)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3945",
    "data-name": "Path 3945",
    d: "M394.965,111.435l2.389,1.379,2.4-1.386-2.4-1.386Z",
    transform: "translate(-394.965 -110.041)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2345",
    "data-name": "Group 2345",
    transform: "translate(99.195 57.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3946",
    "data-name": "Path 3946",
    d: "M398.9,109.662v2.761l-2.408-1.387v-2.761Z",
    transform: "translate(-396.494 -103.552)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3947",
    "data-name": "Path 3947",
    d: "M398.093,110.774v2.761l7.859-4.724v-2.753Z",
    transform: "translate(-395.692 -104.664)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3948",
    "data-name": "Path 3948",
    d: "M406.754,106.523l-7.859,4.717-2.4-1.386,7.872-4.724Z",
    transform: "translate(-396.494 -105.13)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2346",
    "data-name": "Group 2346",
    transform: "translate(83.085 57.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3949",
    "data-name": "Path 3949",
    d: "M387.35,106.938v9.2l2.408-1.386v-9.2Z",
    transform: "translate(-384.968 -104.165)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3950",
    "data-name": "Path 3950",
    d: "M388.152,106.936v9.2l-2.389-1.386v-9.2Z",
    transform: "translate(-385.763 -104.163)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3951",
    "data-name": "Path 3951",
    d: "M385.763,106.022l2.389,1.379,2.4-1.387-2.4-1.386Z",
    transform: "translate(-385.763 -104.628)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2347",
    "data-name": "Group 2347",
    transform: "translate(85.381 49.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3952",
    "data-name": "Path 3952",
    d: "M389.7,104.25v2.761l-2.408-1.386v-2.761Z",
    transform: "translate(-387.292 -98.14)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3953",
    "data-name": "Path 3953",
    d: "M388.892,105.362v2.761l7.859-4.724v-2.753Z",
    transform: "translate(-386.49 -99.252)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3954",
    "data-name": "Path 3954",
    d: "M397.553,101.111l-7.859,4.717-2.4-1.386,7.872-4.724Z",
    transform: "translate(-387.292 -99.717)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2348",
    "data-name": "Group 2348",
    transform: "translate(69.186 49.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3955",
    "data-name": "Path 3955",
    d: "M378.092,101.583v9.2L380.5,109.4v-9.2Z",
    transform: "translate(-375.71 -98.81)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3956",
    "data-name": "Path 3956",
    d: "M378.894,101.58v9.2l-2.388-1.386v-9.2Z",
    transform: "translate(-376.505 -98.808)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3957",
    "data-name": "Path 3957",
    d: "M376.505,100.667l2.388,1.379,2.4-1.387-2.4-1.386Z",
    transform: "translate(-376.505 -99.273)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2349",
    "data-name": "Group 2349",
    transform: "translate(71.481 41.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3958",
    "data-name": "Path 3958",
    d: "M380.442,98.894v2.761l-2.408-1.386V97.508Z",
    transform: "translate(-378.034 -92.784)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3959",
    "data-name": "Path 3959",
    d: "M379.634,100.007v2.761l7.859-4.724V95.29Z",
    transform: "translate(-377.232 -93.896)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3960",
    "data-name": "Path 3960",
    d: "M388.295,95.755l-7.859,4.717-2.4-1.386,7.872-4.724Z",
    transform: "translate(-378.034 -94.362)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2350",
    "data-name": "Group 2350",
    transform: "translate(55.371 41.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3961",
    "data-name": "Path 3961",
    d: "M368.891,96.313v9.2l2.408-1.386v-9.2Z",
    transform: "translate(-366.509 -93.54)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3962",
    "data-name": "Path 3962",
    d: "M369.693,96.31v9.2l-2.389-1.386v-9.2Z",
    transform: "translate(-367.304 -93.537)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3963",
    "data-name": "Path 3963",
    d: "M367.3,95.4l2.389,1.379,2.4-1.386L369.693,94Z",
    transform: "translate(-367.304 -94.003)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2351",
    "data-name": "Group 2351",
    transform: "translate(57.667 33.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3964",
    "data-name": "Path 3964",
    d: "M371.241,93.624v2.761L368.833,95V92.238Z",
    transform: "translate(-368.833 -87.514)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3965",
    "data-name": "Path 3965",
    d: "M370.432,94.736V97.5l7.859-4.724V90.02Z",
    transform: "translate(-368.031 -88.626)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3966",
    "data-name": "Path 3966",
    d: "M379.094,90.485,371.234,95.2l-2.4-1.386,7.872-4.724Z",
    transform: "translate(-368.833 -89.091)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2352",
    "data-name": "Group 2352",
    transform: "translate(41.472 33.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3967",
    "data-name": "Path 3967",
    d: "M359.632,90.957v9.2l2.408-1.386v-9.2Z",
    transform: "translate(-357.25 -88.184)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3968",
    "data-name": "Path 3968",
    d: "M360.434,90.955v9.2l-2.388-1.386v-9.2Z",
    transform: "translate(-358.046 -88.182)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3969",
    "data-name": "Path 3969",
    d: "M358.046,90.041l2.388,1.379,2.4-1.386-2.4-1.386Z",
    transform: "translate(-358.046 -88.647)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2353",
    "data-name": "Group 2353",
    transform: "translate(43.767 25.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3970",
    "data-name": "Path 3970",
    d: "M361.983,88.269V91.03l-2.408-1.386V86.882Z",
    transform: "translate(-359.575 -82.158)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3971",
    "data-name": "Path 3971",
    d: "M361.174,89.381v2.761l7.859-4.724V84.664Z",
    transform: "translate(-358.773 -83.27)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3972",
    "data-name": "Path 3972",
    d: "M369.835,85.13l-7.859,4.717-2.4-1.386,7.872-4.724Z",
    transform: "translate(-359.575 -83.736)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2354",
    "data-name": "Group 2354",
    transform: "translate(27.743 24.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3973",
    "data-name": "Path 3973",
    d: "M350.488,85.516v9.2l2.408-1.386v-9.2Z",
    transform: "translate(-348.106 -82.743)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3974",
    "data-name": "Path 3974",
    d: "M351.29,85.514v9.2L348.9,93.33v-9.2Z",
    transform: "translate(-348.902 -82.741)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3975",
    "data-name": "Path 3975",
    d: "M348.9,84.6l2.388,1.379,2.4-1.386-2.4-1.386Z",
    transform: "translate(-348.902 -83.206)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2355",
    "data-name": "Group 2355",
    transform: "translate(30.039 17.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3976",
    "data-name": "Path 3976",
    d: "M352.838,82.828v2.761L350.431,84.2V81.441Z",
    transform: "translate(-350.431 -76.718)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3977",
    "data-name": "Path 3977",
    d: "M352.03,83.94V86.7l7.859-4.724V79.223Z",
    transform: "translate(-349.629 -77.83)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3978",
    "data-name": "Path 3978",
    d: "M360.691,79.689l-7.859,4.717-2.4-1.386,7.872-4.724Z",
    transform: "translate(-350.431 -78.295)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2356",
    "data-name": "Group 2356",
    transform: "translate(13.929 16.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3979",
    "data-name": "Path 3979",
    d: "M341.287,80.178v9.2l2.408-1.386v-9.2Z",
    transform: "translate(-338.905 -77.405)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3980",
    "data-name": "Path 3980",
    d: "M342.089,80.175v9.2L339.7,87.992V78.8Z",
    transform: "translate(-339.701 -77.403)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3981",
    "data-name": "Path 3981",
    d: "M339.7,79.262l2.388,1.379,2.4-1.386-2.4-1.386Z",
    transform: "translate(-339.701 -77.868)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2357",
    "data-name": "Group 2357",
    transform: "translate(16.224 9.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3982",
    "data-name": "Path 3982",
    d: "M343.637,77.558v2.761l-2.408-1.386V76.171Z",
    transform: "translate(-341.229 -71.447)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3983",
    "data-name": "Path 3983",
    d: "M342.829,78.67v2.761l7.859-4.724V73.953Z",
    transform: "translate(-340.428 -72.559)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3984",
    "data-name": "Path 3984",
    d: "M351.49,74.419l-7.859,4.717-2.4-1.386,7.872-4.724Z",
    transform: "translate(-341.229 -73.025)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2358",
    "data-name": "Group 2358",
    transform: "translate(0.029 8.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3985",
    "data-name": "Path 3985",
    d: "M332.029,74.822v9.2l2.408-1.386v-9.2Z",
    transform: "translate(-329.647 -72.05)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3986",
    "data-name": "Path 3986",
    d: "M332.831,74.82v9.2l-2.388-1.386v-9.2Z",
    transform: "translate(-330.442 -72.047)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3987",
    "data-name": "Path 3987",
    d: "M330.442,73.906l2.388,1.379,2.4-1.386-2.4-1.386Z",
    transform: "translate(-330.442 -72.512)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2359",
    "data-name": "Group 2359",
    transform: "translate(2.325 1.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3988",
    "data-name": "Path 3988",
    d: "M334.379,72.066v2.761l-2.408-1.386V70.679Z",
    transform: "translate(-331.971 -65.955)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3989",
    "data-name": "Path 3989",
    d: "M333.571,73.178v2.761l7.859-4.724V68.461Z",
    transform: "translate(-331.169 -67.067)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3990",
    "data-name": "Path 3990",
    d: "M342.232,68.926l-7.859,4.717-2.4-1.386,7.872-4.724Z",
    transform: "translate(-331.971 -67.533)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2360",
    "data-name": "Group 2360",
    transform: "translate(0 6.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3991",
    "data-name": "Path 3991",
    d: "M464.443,149.582v2.761l2.408-1.386V148.2Z",
    transform: "translate(-263.232 -31.723)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3992",
    "data-name": "Path 3992",
    d: "M531.641,188.01v2.761L330.423,74.3V71.545Z",
    transform: "translate(-330.423 -70.151)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3993",
    "data-name": "Path 3993",
    d: "M330.423,72.01,531.641,188.476l2.4-1.386L332.811,70.617Z",
    transform: "translate(-330.423 -70.617)",
    fill: "#e5e9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2361",
    "data-name": "Group 2361",
    transform: "translate(198.819 122.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3994",
    "data-name": "Path 3994",
    d: "M464.436,149.6l10.982,18.283,2.408-1.386-10.982-18.283Z",
    transform: "translate(-462.054 -148.211)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3995",
    "data-name": "Path 3995",
    d: "M465.238,149.595l10.982,18.283-2.389-1.386L462.85,148.216Z",
    transform: "translate(-462.85 -148.209)",
    fill: "#ced3f4"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2363",
    "data-name": "Group 2363",
    transform: "translate(41.382 53.484)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3996",
    "data-name": "Path 3996",
    d: "M367.587,108.647v2.761l2.408-1.386V107.26Z",
    transform: "translate(-353.173 -98.926)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3997",
    "data-name": "Path 3997",
    d: "M372.407,110.964v2.761l-14.421-8.334v-2.753Z",
    transform: "translate(-357.986 -101.244)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3998",
    "data-name": "Path 3998",
    d: "M357.986,103.1l14.421,8.327,2.4-1.386-14.433-8.334Z",
    transform: "translate(-357.986 -101.709)",
    fill: "#e5e9ff"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2364",
    "data-name": "Group 2364",
    transform: "translate(55.712)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3999",
    "data-name": "Path 3999",
    d: "M373.1,70.806v2.761l2.408-1.386V69.419Z",
    transform: "translate(-364.739 -64.414)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4000",
    "data-name": "Path 4000",
    d: "M375.9,72.012v2.761l-8.368-5.006V67.013Z",
    transform: "translate(-367.531 -65.62)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4001",
    "data-name": "Path 4001",
    d: "M367.531,67.479l8.368,5,2.4-1.386-8.38-5.006Z",
    transform: "translate(-367.531 -66.085)",
    fill: "#e5e9ff"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2365",
    "data-name": "Group 2365",
    transform: "translate(61.659 5.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4002",
    "data-name": "Path 4002",
    d: "M373.079,70.828,384.018,89l2.408-1.386L375.487,69.442Z",
    transform: "translate(-370.697 -69.442)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4003",
    "data-name": "Path 4003",
    d: "M373.881,70.826,384.82,89l-2.388-1.387L371.492,69.447Z",
    transform: "translate(-371.492 -69.439)",
    fill: "#ced3f4"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2366",
    "data-name": "Group 2366",
    transform: "translate(39.007 12.432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4004",
    "data-name": "Path 4004",
    d: "M357.991,76.675v50.241l2.408-1.387V75.289Z",
    transform: "translate(-355.609 -73.902)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4005",
    "data-name": "Path 4005",
    d: "M358.792,76.673v50.241l-2.389-1.387V75.294Z",
    transform: "translate(-356.404 -73.9)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4006",
    "data-name": "Path 4006",
    d: "M356.4,75.759l2.389,1.379,2.4-1.386-2.4-1.386Z",
    transform: "translate(-356.404 -74.365)",
    fill: "#e5e9ff"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2367",
    "data-name": "Group 2367",
    transform: "translate(55.897 31.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4007",
    "data-name": "Path 4007",
    d: "M369.241,89.175v50.241l2.408-1.387V87.789Z",
    transform: "translate(-366.859 -86.402)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4008",
    "data-name": "Path 4008",
    d: "M370.042,89.173v50.241l-2.388-1.387V87.794Z",
    transform: "translate(-367.654 -86.4)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4009",
    "data-name": "Path 4009",
    d: "M367.654,88.259l2.388,1.379,2.4-1.386-2.4-1.387Z",
    transform: "translate(-367.654 -86.865)",
    fill: "#e5e9ff"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2368",
    "data-name": "Group 2368",
    transform: "translate(41.382 1.486)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4010",
    "data-name": "Path 4010",
    d: "M360.394,74.013v2.761l-2.408-1.386V72.626Z",
    transform: "translate(-357.986 -64.292)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4011",
    "data-name": "Path 4011",
    d: "M359.586,76.33v2.761l14.421-8.334V68Z",
    transform: "translate(-357.185 -66.61)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4012",
    "data-name": "Path 4012",
    d: "M374.808,68.469,360.388,76.8l-2.4-1.386,14.433-8.334Z",
    transform: "translate(-357.986 -67.075)",
    fill: "#e5e9ff"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2369",
    "data-name": "Group 2369",
    transform: "translate(58.061 23.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4013",
    "data-name": "Path 4013",
    d: "M371.5,88.483v2.761L369.1,89.857V87.1Z",
    transform: "translate(-369.095 -78.762)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4014",
    "data-name": "Path 4014",
    d: "M370.695,90.8v2.761l14.421-8.334V82.474Z",
    transform: "translate(-368.294 -81.08)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4015",
    "data-name": "Path 4015",
    d: "M385.918,82.939,371.5,91.266l-2.4-1.386,14.433-8.334Z",
    transform: "translate(-369.095 -81.545)",
    fill: "#e5e9ff"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2370",
    "data-name": "Group 2370",
    transform: "translate(47.269 4.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4016",
    "data-name": "Path 4016",
    d: "M364.315,76.347v2.761l-2.408-1.386V74.96Z",
    transform: "translate(-361.907 -66.626)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4017",
    "data-name": "Path 4017",
    d: "M363.507,78.664v2.761l14.421-8.334V70.337Z",
    transform: "translate(-361.105 -68.944)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4018",
    "data-name": "Path 4018",
    d: "M378.729,70.8,364.309,79.13l-2.4-1.386,14.433-8.334Z",
    transform: "translate(-361.907 -69.409)",
    fill: "#e5e9ff"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2371",
    "data-name": "Group 2371",
    transform: "translate(39.035 9.675)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4019",
    "data-name": "Path 4019",
    d: "M361.992,77.249V80.01l2.408-1.386V75.863Z",
    transform: "translate(-353.631 -70.857)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4020",
    "data-name": "Path 4020",
    d: "M364.791,78.456v2.761l-8.368-5.006V73.457Z",
    transform: "translate(-356.423 -72.064)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4021",
    "data-name": "Path 4021",
    d: "M356.423,73.923l8.368,5,2.4-1.387-8.38-5.005Z",
    transform: "translate(-356.423 -72.529)",
    fill: "#e5e9ff"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2372",
    "data-name": "Group 2372",
    transform: "translate(45.004 14.704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4022",
    "data-name": "Path 4022",
    d: "M361.985,77.265l10.982,18.283,2.408-1.386L364.393,75.879Z",
    transform: "translate(-359.603 -75.879)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4023",
    "data-name": "Path 4023",
    d: "M362.787,77.263l10.982,18.283-2.389-1.386L360.4,75.884Z",
    transform: "translate(-360.399 -75.876)",
    fill: "#ced3f4"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2373",
    "data-name": "Group 2373",
    transform: "translate(30.359 32.108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4024",
    "data-name": "Path 4024",
    d: "M380.986,142.589l-30.342-17.518V94.7l20.087,11.6,10.255,26.946Z",
    transform: "translate(-350.644 -83.849)",
    fill: "#ced3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4025",
    "data-name": "Path 4025",
    d: "M370.854,123.992v9.349l19.01-10.848v-9.349Z",
    transform: "translate(-340.512 -74.6)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4026",
    "data-name": "Path 4026",
    d: "M383.034,95.2l-19.01,10.848,10.254,26.946,19.01-10.848Z",
    transform: "translate(-343.936 -83.598)",
    fill: "#afb6e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4027",
    "data-name": "Path 4027",
    d: "M364.87,108.306l8.984,23.608,19.01-10.848-9.028-23.722Z",
    transform: "translate(-343.512 -82.522)",
    fill: "#0d37c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4029",
    "data-name": "Path 4029",
    d: "M369.654,87.471l-19.01,10.848,20.087,11.6,19.01-10.848Z",
    transform: "translate(-350.644 -87.471)",
    fill: "#e5e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4030",
    "data-name": "Path 4030",
    d: "M370.724,105.537,350.644,94.7l20.087,11.6,19.01-10.848Z",
    transform: "translate(-350.644 -83.849)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4031",
    "data-name": "Path 4031",
    d: "M355.645,99.307V117.8l22.834,13.183v-.056l-8.992-23.63Z",
    transform: "translate(-348.137 -81.537)",
    fill: "#0d37c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4032",
    "data-name": "Path 4032",
    d: "M356.345,117.591V99.712l-.7-.4V117.8l22.834,13.183v-.056l-.273-.717Z",
    transform: "translate(-348.137 -81.537)",
    fill: "#5066e7"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceImage);
export default __webpack_public_path__ + "static/media/maintenance-image.82d60d3db6873707a5473ef209269760.svg";
export { ForwardRef as ReactComponent };